/* eslint-disable */
import axios from "axios"
import { useEffect, useMemo, useRef, useState } from "react"
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap"
import * as XLSX from "xlsx"
import { saveAs } from "file-saver"
import ExcelJS from "exceljs"
import Swal from "sweetalert2"
import {
  FaBriefcase,
  FaCheckCircle,
  FaDownload,
  FaFileExcel,
  FaEye,
  FaClipboardCheck,
  FaPhoneAlt,
  FaTimes,
  FaUserCheck,
  FaUsers,
} from "react-icons/fa"
import CompanySelector from "ATSComponents/Common/CompanySelector"
// Add these imports at the top
import { Badge, OverlayTrigger, Tooltip } from "reactstrap" // or keep using reactstrap
// Add lucide-react icons needed
import { Bot, User, Phone, Briefcase, Calendar, Play, MessageCircle, ListChecks, Volume2, Sparkles, Star, Target, TrendingUp, AlertCircle } from "lucide-react"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"
const audioCache = {}
const screeningModalStyles = `
  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  @keyframes slideInLeft {
    from { opacity: 0; transform: translateX(-20px); }
    to { opacity: 1; transform: translateX(0); }
  }
  @keyframes slideInRight {
    from { opacity: 0; transform: translateX(20px); }
    to { opacity: 1; transform: translateX(0); }
  }
  @keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.05); }
  }
  @keyframes shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }
  .screening-modal .modal-content {
    border: none !important;
    border-radius: 16px !important;
    overflow: hidden;
    box-shadow: 0 25px 60px rgba(0,0,0,0.15) !important;
  }
  .screening-modal .modal-header .btn-close {
    filter: brightness(0) invert(1);
    opacity: 0.8;
  }
  .screening-modal .modal-header .btn-close:hover { opacity: 1; }
  .recruiter-detail-modal {
    width: 96vw !important;
    max-width: min(1600px, 96vw) !important;
  }
  .recruiter-detail-modal .modal-content {
    border: none;
    border-radius: 14px;
    overflow: hidden;
  }
  .recruiter-detail-modal-table-wrap {
    max-height: 72vh;
    overflow: auto !important;
  }
  .recruiter-detail-modal-table {
    min-width: 1100px;
  }
  .recruiter-report-hero-orb {
    pointer-events: none;
  }
  .recruiter-report-filter-input {
    position: relative;
    z-index: 2;
    pointer-events: auto;
  }
  @media (max-width: 575px) {
    .recruiter-detail-modal {
      width: calc(100vw - 16px) !important;
      max-width: calc(100vw - 16px) !important;
      margin: 8px auto !important;
    }
    .recruiter-detail-modal-table-wrap {
      max-height: 68vh;
    }
  }
  .screening-info-card { transition: all 0.25s ease; cursor: default; }
  .screening-info-card:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.08); }
  .screening-question-item { transition: all 0.2s ease; }
  .screening-question-item:hover { transform: translateX(4px); box-shadow: 0 2px 8px rgba(124,58,237,0.12); }
  .screening-chat-bubble { transition: all 0.2s ease; }
  .screening-chat-bubble:hover { transform: scale(1.01); }
  .screening-section { animation: fadeInUp 0.5s ease forwards; opacity: 0; }
  .screening-avatar-candidate { transition: all 0.3s ease; }
  .screening-avatar-candidate:hover { transform: scale(1.1); }
  .screening-recording-card { transition: all 0.3s ease; }
  .screening-recording-card:hover { box-shadow: 0 4px 16px rgba(217,119,6,0.2); }
  .screening-transcript-container::-webkit-scrollbar { width: 6px; }
  .screening-transcript-container::-webkit-scrollbar-track { background: transparent; }
  .screening-transcript-container::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 3px; }
  .screening-transcript-container::-webkit-scrollbar-thumb:hover { background: #9ca3af; }
`
const capitalizeFirst = str => {
  if (!str || str === "-") return str
  return str.replace(/\b\w/g, c => c.toUpperCase())
}

const RecordingPlayer = ({ src, currentPlayingRef }) => {
  const [audioSrc, setAudioSrc] = useState(audioCache[src] || null)
  const [loading, setLoading] = useState(!audioCache[src])
  const [error, setError] = useState(false)
  const audioRef = useRef(null)

  useEffect(() => {
    if (!src) return

    if (audioCache[src]) {
      setAudioSrc(audioCache[src])
      setLoading(false)
      return
    }

    const fetchAudio = async () => {
      try {
        const response = await axios.get(src, { responseType: "blob" })
        if (!response.data || response.data.size < 500) {
          setError(true)
          return
        }

        const blobUrl = URL.createObjectURL(response.data)
        audioCache[src] = blobUrl
        setAudioSrc(blobUrl)
      } catch (err) {
        console.error("Audio fetch failed:", err)
        setError(true)
      } finally {
        setLoading(false)
      }
    }

    fetchAudio()
  }, [src])

  const handlePlay = () => {
    if (currentPlayingRef.current && currentPlayingRef.current !== audioRef.current) {
      currentPlayingRef.current.pause()
    }
    currentPlayingRef.current = audioRef.current
  }

  if (error) {
    return (
      <div style={{ fontSize: 12, color: "#b91c1c", padding: "8px 0" }}>
        Audio File is too Small
      </div>
    )
  }

  return (
    <div style={{ width: "100%" }}>
      {loading && (
        <div style={{ fontSize: 12, color: "#64748b", padding: "6px 0" }}>
          Loading audio...
        </div>
      )}
      {audioSrc && (
        <audio
          ref={audioRef}
          controls
          preload="metadata"
          onPlay={handlePlay}
          style={{ width: "100%", display: loading ? "none" : "block" }}
          src={audioSrc}
        />
      )}
    </div>
  )
}
const getRecordingPlayUrl = url => {
  if (!url) return null
  return `https://ats.bharatpayroll.com/qxbox/api/v1/play-recording/?url=${encodeURIComponent(url)}`
}
const formatDateTime = value => {
  if (!value) return "-"
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return "-"
  const dd = String(date.getDate()).padStart(2, "0")
  const mm = String(date.getMonth() + 1).padStart(2, "0")
  const yyyy = date.getFullYear()
  let hr = date.getHours()
  const min = String(date.getMinutes()).padStart(2, "0")
  const sec = String(date.getSeconds()).padStart(2, "0")
  const ampm = hr >= 12 ? "PM" : "AM"
  hr = hr % 12
  hr = hr || 12
  return `${dd}-${mm}-${yyyy} ${String(hr).padStart(2, "0")}:${min}:${sec} ${ampm}`
}
const columnMappings = {
  // id: "ID",
  // job_candidate_id: "Job Candidate ID",
  // job__job_id: "Job ID",
  job__job_title: "Job Title",
  job_title: "Job Title",
  // job_candidate__job__job_id: "Job ID",
  job_candidate__job__job_title: "Job Title",
  candidate_name: "Candidate Name",
  job_candidate__candidate_name: "Candidate Name",
  first_name: "Candidate Name",
  candidate_email: "Candidate Email",
  candidate__email: "Candidate Email",
  job_candidate__candidate_email: "Candidate Email",
  email: "Candidate Email",
  candidate_phone: "Candidate Phone",
  job_candidate__candidate_phone: "Candidate Phone",
  mobile_phone: "Candidate Phone",
  status: "Status",
  // added_from: "Added From",
  subject: "Subject",
  to_addresses: "To Addresses",
  from_address: "From Address",
  created_by_name: "Created By",
  email_id: "Email ID",
  applied_date: "Applied On",
  sent_at: "Sent On",
  created_at: "Created On",
  interview_date: "Interview Date and Time",
  interview_time: "Interview Date and Time",
  interview_date_time: "Interview Date and Time",
  time_zone: "Timezone",
  timezone: "Timezone",
  calendar_event_id: "Calendar Event ID",
  event_id: "Calendar Event ID",
  panel_members: "Panel Members",
  interview_type: "Event Type",
  interview_subtype: "Event Subtype",
  interview_sub_type: "Event Subtype",
  interview_subject: "Interview Subject",
  interview_status: "Interview Status",
}
const getTodayFormatted = () => {
  const today = new Date()
  const offset = today.getTimezoneOffset()
  const local = new Date(today.getTime() - offset * 60000)
  return local.toISOString().split("T")[0]
}

const formatDateLabel = value => {
  if (!value) return "All time"
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  })
}
const toNumber = value => {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}
const firstDefinedNumber = (...values) => {
  for (const value of values) {
    const parsed = Number(value)
    if (Number.isFinite(parsed)) {
      return parsed
    }
  }
  return undefined
}
const pickRecruiterJobMetrics = recruiter => ({
  jobsAdded: firstDefinedNumber(
    recruiter?.jobs?.jobs_added,
    recruiter?.jobs_added,
    recruiter?.jobs?.jobsAdded,
    recruiter?.jobsAdded
  ),
  jobsUpdated: firstDefinedNumber(
    recruiter?.jobs?.jobs_updated,
    recruiter?.jobs_updated,
    recruiter?.jobs?.jobsUpdated,
    recruiter?.jobsUpdated
  ),
  totalOpenings: firstDefinedNumber(
    recruiter?.jobs?.total_openings,
    recruiter?.total_openings,
    recruiter?.jobs?.openings_count,
    recruiter?.openings_count,
    recruiter?.jobs?.totalOpenings,
    recruiter?.totalOpenings
  ),
})
const getRecruiterJobMetrics = recruiter => ({
  jobsAdded: pickRecruiterJobMetrics(recruiter).jobsAdded ?? 0,
  jobsUpdated: pickRecruiterJobMetrics(recruiter).jobsUpdated ?? 0,
  totalOpenings: pickRecruiterJobMetrics(recruiter).totalOpenings ?? 0,
})
const sumUniqueJobMetric = (field, ...jobLists) =>
  [...new Map(
    jobLists
      .flat()
      .filter(Boolean)
      .map((job, index) => [
        String(job.job_id || job.job_title || job.title || `job-${index}`),
        job,
      ])
  ).values()].reduce((total, job) => total + toNumber(job?.[field]), 0)
const getEmailsSentCount = recruiter =>
  firstDefinedNumber(
    recruiter?.emails?.emails_sent_count,
    recruiter?.emails_sent_count,
    recruiter?.emailsSentCount,
    recruiter?.emails_sent,
  ) ??
  sumUniqueJobMetric(
    "emails_sent_count",
    recruiter?.jobs?.created_job_titles,
    recruiter?.jobs?.handled_job_titles
  )
const getInitials = value =>
  String(value || "R")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part.charAt(0).toUpperCase())
    .join("")
const tdStyle = {
  padding: "8px 12px",
  borderBottom: "1px solid #edf2f7",
  borderRight: "1px solid #f1f5f9",
  color: "#475569",
  background: "#fff",
  verticalAlign: "center",
  textAlign: "center",
  fontSize: "0.875rem",
}
const prettifyKey = key =>
  key === "_company_name" ||
  key === "company__company_name" ||
  key === "job__company_id__company_name" ||
  key === "job_candidate__job__company_id__company_name"
    ? "Company"
    : key === "candidate__first_name" || key === "first_name"
    ? "Candidate Name"
    : key === "stage" || key === "pipeline_status" || key === "candidate_status" || key === "stage_name"
    ? "Candidate Pipeline Stage"
    : key === "recording_url"
    ? "Recording URL"
    : columnMappings[key] ||
      String(key).replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())

const getCandidateFullName = item => {
  const directName =
    item?.candidate_name ||
    item?.job_candidate__candidate_name ||
    item?.candidate__name ||
    ""

  if (directName) return directName

  const firstName = item?.candidate__first_name || item?.first_name || ""
  const middleName = item?.candidate__middle_name || item?.middle_name || ""
  const lastName = item?.candidate__last_name || item?.last_name || ""

  return `${firstName} ${middleName} ${lastName}`.trim() || "-"
}

const getCandidateEmailValue = item =>
  item?.candidate_email ||
  item?.job_candidate__candidate_email ||
  item?.candidate__email ||
  item?.email ||
  "-"

export const RECRUITER_PROFILE_TABS = [
  {
    key: "candidates_db",
    label: "Added in DB",
    icon: "🗄️",
    color: "#7c3aed",
    bg: "#f5f3ff",
    border: "#c4b5fd",
    detailKey: "candidatesDetailDb",
    countKey: "candidatesAddedDb",
  },
  {
    key: "candidates_added",
    label: "Candidates Added",
    icon: "👤",
    color: "#0891b2",
    bg: "#ecfeff",
    border: "#a5f3fc",
    detailKey: "candidatesDetail",
    countKey: "candidatesAdded",
  },
  {
    key: "shortlisted",
    label: "Shortlisted",
    icon: "⭐",
    color: "#d97706",
    bg: "#fff7ed",
    border: "#fed7aa",
    detailKey: "shortlistedDetail",
    countKey: "shortlistedCount",
  },
  {
    key: "rejected",
    label: "Rejected",
    icon: "❌",
    color: "#dc2626",
    bg: "#fff1f2",
    border: "#fecdd3",
    detailKey: "rejectedDetail",
    countKey: "rejectedCount",
  },
  {
    key: "tests_sent",
    label: "Tests Sent",
    icon: "📋",
    color: "#db2777",
    bg: "#fdf2f8",
    border: "#fbcfe8",
    detailKey: "testsSentDetail",
    countKey: "testsSentCount",
  },
  {
    key: "emails",
    label: "Email Sent",
    icon: "✉️",
    color: "#0f766e",
    bg: "#f0fdfa",
    border: "#99f6e4",
    detailKey: "emailsDetail",
    countKey: "emailsSentCount",
  },
  {
    key: "click_to_call",
    label: "Click To Call",
    icon: "📞",
    color: "#2563eb",
    bg: "#eff6ff",
    border: "#bfdbfe",
    detailKey: "clickToCallDetail",
    countKey: "clickToCallCount",
  },
  {
    key: "screening",
    label: "Screening Calls",
    icon: "🎙️",
    color: "#059669",
    bg: "#ecfdf5",
    border: "#a7f3d0",
    detailKey: "screeningCallDetail",
    countKey: "screeningCallCount",
  },
]
const TAB_COLUMNS = {
  candidates_db: ["candidate_name", "job_candidate__candidate_name", "first_name", "candidate_email", "job_candidate__candidate_email", "email", "candidate_phone", "job_candidate__candidate_phone", "mobile_phone", "created_at", "applied_date"],
  candidates_added: ["_company_name", "job__job_title", "job_candidate__job__job_title", "candidate_name", "job_candidate__candidate_name", "first_name", "candidate_email", "job_candidate__candidate_email", "email", "candidate_phone", "job_candidate__candidate_phone", "mobile_phone", "stage", "applied_date", "created_at"],
  shortlisted: ["_company_name", "job__job_title", "job_candidate__job__job_title", "candidate_name", "job_candidate__candidate_name", "first_name", "candidate_email", "job_candidate__candidate_email", "email", "candidate_phone", "job_candidate__candidate_phone", "mobile_phone", "stage", "applied_date", "created_at"],
  rejected: ["_company_name", "job__job_title", "job_candidate__job__job_title", "candidate_name", "job_candidate__candidate_name", "first_name", "candidate_email", "job_candidate__candidate_email", "email", "candidate_phone", "job_candidate__candidate_phone", "mobile_phone", "stage", "created_at", "recording_url"],
  tests_sent: ["_company_name", "job__job_title", "job_candidate__job__job_title", "candidate_name", "job_candidate__candidate_name", "candidate__first_name", "first_name", "candidate_email", "job_candidate__candidate_email", "candidate__email", "email", "candidate_phone", "job_candidate__candidate_phone", "mobile_phone", "candidate_stage", "sent_at", "created_at"],
  emails: ["_company_name", "job__job_title", "job_candidate__job__job_title", "job_candidate__candidate_name", "candidate_name", "subject", "to_addresses", "from_address", "created_by_name", "job_candidate__stage", "sent_at", "created_at"],
  click_to_call: ["_company_name", "job__job_title", "job_candidate__job__job_title", "candidate_name", "job_candidate__candidate_name", "first_name", "candidate_email", "job_candidate__candidate_email", "email", "candidate_phone", "job_candidate__candidate_phone", "mobile_phone", "job_candidate__stage", "created_at"],
  screening: ["_company_name", "job__job_title", "job_candidate__job__job_title", "candidate_name", "job_candidate__candidate_name", "first_name", "candidate_email", "job_candidate__candidate_email", "email", "candidate_phone", "job_candidate__candidate_phone", "mobile_phone", "stage", "created_at", "recording_url"],
}

const dedupeColumnsByHeader = columns => {
  const seenHeaders = new Set()
  return columns.filter(column => {
    const header = prettifyKey(column)
    if (seenHeaders.has(header)) return false
    seenHeaders.add(header)
    return true
  })
}

const formatDetailValue = (key, value, item) => {
  if (key.includes("candidate__first_name") || key === "first_name") {
    return getCandidateFullName(item)
  }
  if (
    key === "candidate_name" ||
    key === "job_candidate__candidate_name" ||
    key === "candidate__name"
  ) {
    return getCandidateFullName(item)
  }
  if (
    key === "candidate_email" ||
    key === "job_candidate__candidate_email" ||
    key === "candidate__email" ||
    key === "email"
  ) {
    return getCandidateEmailValue(item)
  }
  if (value === null || value === undefined || value === "") return "-"
  if (
    typeof value === "string" &&
    (key.includes("date") || key.includes("at") || key.includes("created"))
  ) {
    const parsed = new Date(value)
    if (!Number.isNaN(parsed.getTime())) {
      let hours = parsed.getHours()
      const minutes = String(parsed.getMinutes()).padStart(2, "0")
      const seconds = String(parsed.getSeconds()).padStart(2, "0")
      const ampm = hours >= 12 ? "PM" : "AM"
      hours = hours % 12
      hours = hours || 12
      const dd = String(parsed.getDate()).padStart(2, "0")
      const mm = String(parsed.getMonth() + 1).padStart(2, "0")
      const yyyy = parsed.getFullYear()
      return `${dd}-${mm}-${yyyy} ${String(hours).padStart(2, "0")}:${minutes}:${seconds} ${ampm}`
    }
  }
  return String(value)
}
const sanitizeFileName = value =>
  String(value || "recruiter-details")
    .trim()
    .replace(/[\\/:*?"<>|]+/g, "")
    .replace(/\s+/g, "_")

const buildJobTitleList = (...sources) => {
  return [
    ...new Map(
      sources
        .flat()
        .map(item => {
          if (!item) return null

          if (typeof item === "string") {
            const title = item.trim()
            return title ? [title, { job_id: title, title }] : null
          }

          if (typeof item === "object") {
            const title = (
              item.job__job_title ||
              item.job_candidate__job__job_title ||
              item.job_title ||
              item.title ||
              ""
            ).trim()
            const jobId = item.job__job_id || item.job_candidate__job__job_id || item.job_id || title

            return title ? [String(jobId), { job_id: jobId, title }] : null
          }

          return null
        })
        .filter(Boolean)
    ).values(),
  ]
}

const getJobDescriptor = item => {
  if (!item) return null

  if (typeof item === "string") {
    const title = item.trim()
    return title ? { job_id: title, title } : null
  }

  if (typeof item === "object") {
    const title = (
      item.job__job_title ||
      item.job_candidate__job__job_title ||
      item.job_title ||
      item.title ||
      ""
    ).trim()

    if (!title) return null

    const jobId =
      item.job__job_id ||
      item.job_candidate__job__job_id ||
      item.job_id ||
      title

    return {
      job_id: jobId,
      title,
    }
  }

  return null
}

const getJobKey = item => {
  const descriptor = getJobDescriptor(item)
  return descriptor ? String(descriptor.job_id || descriptor.title).trim() : ""
}

const getNormalizedJobTitleKey = value =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ")

const mapRecruiterStatsRow = recruiter => ({
  recruiterId: recruiter.recruiter_id,
  recruiterName: recruiter.recruiter_name,
  recruiterEmail: recruiter.recruiter_email,
  jobTitles: buildJobTitleList(
    recruiter?.jobs?.created_job_titles,
    recruiter?.jobs?.handled_job_titles,
    recruiter?.candidates?.candidates_detail,
    recruiter?.candidates?.shortlisted_detail,
    recruiter?.candidates?.rejected_detail,
    recruiter?.calls?.tests_sent_detail,
    recruiter?.calls?.click_to_call_detail,
    recruiter?.calls?.screening_calls_detail,
    recruiter?.emails?.emails_detail,
    recruiter?.emails_detail
  ),
  ...getRecruiterJobMetrics(recruiter),
  candidatesAddedDb: recruiter?.candidates?.candidates_added_db ?? 0,
  candidatesDetailDb: recruiter?.candidates?.candidates_detail_db ?? [],
  candidatesAdded: recruiter?.candidates?.candidates_added ?? 0,
  candidatesDetail: recruiter?.candidates?.candidates_detail ?? [],
  shortlistedCount: recruiter?.candidates?.shortlisted_count ?? 0,
  shortlistedDetail: recruiter?.candidates?.shortlisted_detail ?? [],
  rejectedCount: recruiter?.candidates?.rejected_count ?? 0,
  rejectedDetail: recruiter?.candidates?.rejected_detail ?? [],
  testsSentCount: recruiter?.calls?.tests_sent_count ?? 0,
  testsSentDetail: recruiter?.calls?.tests_sent_detail ?? [],
  emailsSentCount: getEmailsSentCount(recruiter),
  emailsDetail: recruiter?.emails?.emails_detail ?? recruiter?.emails_detail ?? [],
  clickToCallCount: recruiter?.calls?.click_to_call_count ?? 0,
  clickToCallDetail: recruiter?.calls?.click_to_call_detail ?? [],
  screeningCallCount: recruiter?.calls?.screening_call_count ?? 0,
  screeningCallDetail: recruiter?.calls?.screening_calls_detail ?? [],
  interviewsScheduledCount:
    recruiter?.interviews?.interviews_scheduled_count ??
    recruiter?.interviews_scheduled_count ??
    recruiter?.interviews_created ??
    0,
  interviewsDetail:
    recruiter?.interviews?.scheduled ??
    recruiter?.interviews_scheduled_detail ??
    recruiter?.interviews?.interviews_detail ??
    recruiter?.interviews?.details ??
    [],
})

const normalizeInterviewDetails = rows => {
  const sessions = new Map()

  ;(Array.isArray(rows) ? rows : []).forEach(item => {
    const parentEventId = item.parent_event_id ?? item.calendar_event_id ?? item.calendar_id
    const sessionKey = String(parentEventId ?? `row-${sessions.size}`)
    const candidateNames =
      Array.isArray(item.candidate_names) && item.candidate_names.length
        ? item.candidate_names.filter(Boolean)
        : [
            item.candidate_name,
            [
              item.candidate_id__first_name,
              item.candidate_id__middle_name,
              item.candidate_id__last_name,
            ].filter(Boolean).join(" "),
          ].filter(Boolean)
    const panelMembers = [
      ...(Array.isArray(item.panel_members) ? item.panel_members : []),
      ...(item.panel_member_name || item.panel_member_email
        ? [{ name: item.panel_member_name, email: item.panel_member_email }]
        : []),
    ]

    if (!sessions.has(sessionKey)) {
      sessions.set(sessionKey, {
        ...item,
        parent_event_id: parentEventId,
        candidate_names: [],
        panel_members: [],
        job_title: item.job_title || item.job_id__job_title,
        interview_type: item.interview_type || item.event_type,
        interview_sub_type: item.interview_sub_type || item.event_sub_type,
        subject: item.subject || item.interview_subject,
        status: item.status || item.interview_status,
        interview_time: item.interview_time || item.event_time,
        time_zone:
          item.time_zone ||
          item.timezone ||
          (String(item.interview_time || item.event_time || "").endsWith("Z") ? "UTC" : ""),
        calendar_event_id: item.calendar_event_id || item.calendar_id,
      })
    }

    const session = sessions.get(sessionKey)
    session.candidate_names = [...new Set([...session.candidate_names, ...candidateNames])]
    const panelMap = new Map(
      session.panel_members.map(member => [`${member.name || ""}|${member.email || ""}`, member])
    )
    panelMembers.forEach(member => {
      const normalized = {
        name: member.name || member.full_name || member.email || "-",
        email: member.email || member.email_address || "",
      }
      panelMap.set(`${normalized.name}|${normalized.email}`, normalized)
    })
    session.panel_members = [...panelMap.values()]
    session.candidate_name = session.candidate_names.join(", ")
  })

  return [...sessions.values()]
}

const JobOrderRecruiterReport = () => {
  document.title = "ATS - Recruiter Report"
  const userInfos = JSON.parse(sessionStorage.getItem("user-info") || "{}")
 
  const initialCompanyId =
    userInfos?.user_details?.companies_data?.[0]?.company_id ?? null
  const [companyId, setCompanyId] = useState(initialCompanyId)
  //  const companyName =
  // userInfos?.user_details?.companies_data?.find(
  //   c => c.company_id === companyId
  // )?.company_name ?? "Unknown Company"
  // AFTER

  const [selectedJobId, setSelectedJobId] = useState("")
  const [selectedRecruiter, setSelectedRecruiter] = useState("")
  const [selectedJobTitle, setSelectedJobTitle] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [reportData, setReportData] = useState(null)
  const [jobStats, setJobStats] = useState(null)
  const [detailsLoading, setDetailsLoading] = useState(false)
  const [screeningModal, setScreeningModal] = useState(false)
  const [screeningData, setScreeningData] = useState(null)
  const [screeningType, setScreeningType] = useState("")
  const [screeningLoading, setScreeningLoading] = useState(false)
  const [screeningError, setScreeningError] = useState("")
   const [recruiterProfileModal, setRecruiterProfileModal] = useState({ open: false, row: null })
   const [recruiterProfileTab, setRecruiterProfileTab] = useState("candidates_added")
const getCandidatePipelineStatus = row =>
    row?.pipeline_status ||
    row?.candidate_status ||
    row?.stage ||
    row?.stage_name ||
    row?.application_status ||
    row?.status ||
    "--"
  const handleViewCallTranscript = async (callRow) => {
  const id = callRow?.secondary_external_call_id
  if (!id) return
  setScreeningType("Screening")
  setScreeningData(null)
  setScreeningError("")
  setScreeningModal(true)
  setScreeningLoading(true)
  try {
    const { data } = await axios.get(`/api/v1/get-secondary-evaluation/?id=${id}`)
    const evalData = data?.data || {}
    const transcript = data?.transcript || []
    const recording = data?.recording || ""
    const screeningQuestions = Object.entries(evalData)
      .filter(([key]) => /^\d+$/.test(key))
      .sort(([a], [b]) => Number(a) - Number(b))
      .map(([, value]) => value)
   setScreeningData({
  candidate_name:
    evalData["Candidate Name"] ||
    evalData.candidate_name ||
    callRow.job_candidate__candidate_name ||
    "-",

  candidate_phone:
    evalData["Candidate Phone"] ||
    callRow.job_candidate__candidate_phone ||
    "-",

  agent_name:
    evalData["Agent Name"] ||
    evalData.agent_name ||
    "-",

  job_title:
    evalData.job_position ||
    callRow.job_candidate__job__job_title ||
    "-",

  designation: "-",

  date_of_interview:
    evalData.date_of_interview || "-",

  next_interview:
    evalData["Date And Time For Next Interview"] ||
    evalData["Next Interview Date Time"] ||
    "-",

  // ADD THESE
  sections: evalData.sections || {},
  overall_score: evalData.overall_score ?? null,
  key_strengths: evalData.key_strengths || "",
  priority_improvements:
    evalData.priority_improvements || "",
  overall_recommendation:
    evalData.overall_recommendation || "",

  questions: screeningQuestions,

  transcript,
  recording,
})
  } catch (error) {
    setScreeningError(error?.response?.data?.message || "Failed to fetch evaluation data.")
    setScreeningData(null)
  } finally {
    setScreeningLoading(false)
  }
}
    const previousCompanyIdRef = useRef(initialCompanyId)
  const [detailModal, setDetailModal] = useState({
    open: false,
    title: "",
    recruiterName: "",
    rows: [],
  })
  const currentPlayingRef = useRef(null)

  const today = new Date()
  const format = d => d.toISOString().split("T")[0]
  const todayFormatted = getTodayFormatted()
  const [reportStartDate, setReportStartDate] = useState(todayFormatted)
  const [reportEndDate, setReportEndDate] = useState(todayFormatted)
  const [detailsStartDate, setDetailsStartDate] = useState(todayFormatted)
  const [excelDownloading, setExcelDownloading] = useState(false)
  const [detailsEndDate, setDetailsEndDate] = useState(todayFormatted)
  const companyNameFromApi = useMemo(() => {
  if (!reportData) return null

  // Try the top-level company_name field first
  if (reportData?.company_name) return reportData.company_name

  // Fall back to company_name inside any job title entry
  const allJobs = [
    ...(reportData?.recruiter_details || []).flatMap(r => [
      ...(r?.jobs?.created_job_titles || []),
      ...(r?.jobs?.handled_job_titles || []),
    ]),
  ]
  for (const job of allJobs) {
    if (job?.company_name) return job.company_name
  }
  return null
}, [reportData])

const companyName = useMemo(() => {
  if (String(companyId).toLowerCase() === "all") {
    if (!reportData) return "All Companies"
    const names = new Set(
      [
        ...(reportData?.recruiter_details || []).flatMap(r => [
          ...(r?.jobs?.created_job_titles || []),
          ...(r?.jobs?.handled_job_titles || []),
        ]),
      ]
        .map(j => j?.company_name)
        .filter(Boolean)
    )
    return names.size > 0 ? [...names].join(" | ") : "All Companies"
  }
  return (
    companyNameFromApi ||
    userInfos?.user_details?.companies_data?.find(
      c => String(c.company_id) === String(companyId)
    )?.company_name ||
    "Unknown Company"
  )
}, [companyId, companyNameFromApi, reportData, userInfos])
const isAllCompanies = String(companyId).toLowerCase() === "all"

  const syncDateFilters = ({ start, end }) => {
    setReportStartDate(start)
    setReportEndDate(end)
    setDetailsStartDate(start)
    setDetailsEndDate(end)
  }

  const handleStartDateChange = value => {
    syncDateFilters({ start: value, end: reportEndDate })
  }

  const handleEndDateChange = value => {
    syncDateFilters({ start: reportStartDate, end: value })
  }
  useEffect(() => {
    const loadReport = async () => {
      if (!companyId) {
        setReportData(null)
        return
      }
      const isCompanyChanged = previousCompanyIdRef.current !== companyId
      const shouldShowPageLoader = !reportData || isCompanyChanged

      if (shouldShowPageLoader) {
        setLoading(true)
      }
      setError("")
      try {
        const params = {}
        if (reportStartDate) params.date_from = reportStartDate
        if (reportEndDate) params.date_to = reportEndDate
        const response = await axios.get(
          `/api/v1/company/${companyId}/recruiter-activity-report/`,
          { params }
        )
        setReportData(response?.data || null)
        previousCompanyIdRef.current = companyId
      } catch (err) {
        console.error("Error loading recruiter activity report:", err)
        setError(
          err?.response?.data?.message ||
            "Failed to load recruiter activity report."
        )
        setReportData(null)
      } finally {
        if (shouldShowPageLoader) {
          setLoading(false)
        }
      }
    }
    loadReport()
  }, [companyId, reportStartDate, reportEndDate])
  const companySummary = reportData?.company_summary || {}
  const rawRecruiters = Array.isArray(reportData?.recruiters)
    ? reportData.recruiters
    : []
  const topRecruiters = Array.isArray(reportData?.top_recruiters)
    ? reportData.top_recruiters
    : rawRecruiters
  const recruiterDetails = Array.isArray(reportData?.recruiter_details)
    ? reportData.recruiter_details
    : rawRecruiters
  const recruiterRankMap = useMemo(
    () =>
      new Map(
        topRecruiters.map(recruiter => [
          String(recruiter.recruiter_id), // ✅ FIX
          recruiter.rank,
        ])
      ),
    [topRecruiters]
  )
  const recruiterMetricsMap = useMemo(() => {
    const rawRecruiterMap = new Map(
      rawRecruiters.map(r => [String(r.recruiter_id), r])
    )
    const topRecruiterMap = new Map(
      topRecruiters.map(r => [String(r.recruiter_id), r])
    )

    return new Map(
      recruiterDetails.map(r => {
        const recruiterId = String(r.recruiter_id)
        const rawRecruiter = rawRecruiterMap.get(recruiterId) || {}
        const topRecruiter = topRecruiterMap.get(recruiterId) || {}
        const detailJobMetrics = pickRecruiterJobMetrics(r)
        const rawJobMetrics = pickRecruiterJobMetrics(rawRecruiter)
        const topJobMetrics = pickRecruiterJobMetrics(topRecruiter)

        return [
          recruiterId,
          {
            jobs_updated:
              firstDefinedNumber(
                detailJobMetrics.jobsUpdated,
                rawJobMetrics.jobsUpdated,
                topJobMetrics.jobsUpdated
              ) ?? 0,
            total_openings:
              firstDefinedNumber(
                detailJobMetrics.totalOpenings,
                rawJobMetrics.totalOpenings,
                topJobMetrics.totalOpenings
              ) ?? 0,
            jobs_added:
              firstDefinedNumber(
                detailJobMetrics.jobsAdded,
                topJobMetrics.jobsAdded,
                rawJobMetrics.jobsAdded
              ) ?? 0,
            candidates_added_db:
              rawRecruiter.candidates?.candidates_added_db ??
              r.candidates?.candidates_added_db ??
              0,
            candidates_added:
              r.candidates?.candidates_added ??
              topRecruiter.candidates_added ??
              rawRecruiter.candidates?.candidates_added ??
              0,
            shortlisted:
              r.candidates?.shortlisted_count ??
              topRecruiter.shortlisted ??
              rawRecruiter.candidates?.shortlisted_count ??
              0,
            rejected:
              rawRecruiter.candidates?.rejected_count ??
              r.candidates?.rejected_count ??
              topRecruiter.rejected ??
            0,
            tests_sent:
              r.calls?.tests_sent_count ??
              topRecruiter.tests_sent ??
              rawRecruiter.calls?.tests_sent_count ??
              0,
            emails_sent:
              getEmailsSentCount(rawRecruiter) ||
              getEmailsSentCount(r) ||
              getEmailsSentCount(topRecruiter),
            click_to_call:
              r.calls?.click_to_call_count ??
              topRecruiter.click_to_call ??
              rawRecruiter.calls?.click_to_call_count ??
              0,
            screening_calls:
              r.calls?.screening_call_count ??
              topRecruiter.screening_calls ??
              rawRecruiter.calls?.screening_call_count ??
              0,
          },
        ]
      })
    )
  }, [rawRecruiters, recruiterDetails, topRecruiters])
  const recruiterJobTitleMap = useMemo(() => {
    return new Map(
      topRecruiters.map(r => [
        String(r.recruiter_id), // ✅ FIX
        Array.isArray(r.job_titles) ? r.job_titles : [],
      ])
    )
  }, [topRecruiters])
  const detailRows = useMemo(() => {
    if (!topRecruiters?.length) return []

    return topRecruiters.map(rec => {
      const metrics = recruiterMetricsMap.get(String(rec.recruiter_id)) || {}

      const recruiterDetail = recruiterDetails.find(
        d => String(d.recruiter_id) === String(rec.recruiter_id)
      )
      const rawRecruiterDetail = rawRecruiters.find(
        d => String(d.recruiter_id) === String(rec.recruiter_id)
      )

      const rawCandidateDetails = rawRecruiterDetail?.candidates || {}
      const recruiterCandidateDetails = recruiterDetail?.candidates || {}
      const rawCallDetails = rawRecruiterDetail?.calls || {}
      const recruiterCallDetails = recruiterDetail?.calls || {}
      const rawEmailDetails = rawRecruiterDetail?.emails || {}
      const recruiterEmailDetails = recruiterDetail?.emails || {}

      const created = recruiterDetail?.jobs?.created_job_titles || []

      const handled = recruiterDetail?.jobs?.handled_job_titles || []

      // ✅ Merge + Remove duplicates
      const uniqueJobTitlesFromJobs = [
        ...new Map(
          [...created, ...handled]
            .map(t => {
              if (!t) return null

              // string case
              if (typeof t === "string") {
                const title = t.trim()
                return [title, { job_id: title, title }]
              }

              // object case (FIXED HERE)
              if (typeof t === "object") {
                const title = (t.job_title || t.title || "").trim()
                const jobId = t.job_id || title

                if (!title) return null

                return [jobId, { job_id: jobId, title }]
              }

              return null
            })
            .filter(Boolean)
        ).values(),
      ]

      const uniqueJobTitles = buildJobTitleList(
        uniqueJobTitlesFromJobs,
        rawCandidateDetails.candidates_detail,
        recruiterCandidateDetails.candidates_detail,
        rawCandidateDetails.shortlisted_detail,
        recruiterCandidateDetails.shortlisted_detail,
        rawCandidateDetails.rejected_detail,
        recruiterCandidateDetails.rejected_detail,
        rawCallDetails.tests_sent_detail,
        recruiterCallDetails.tests_sent_detail,
        rawCallDetails.click_to_call_detail,
        recruiterCallDetails.click_to_call_detail,
        rawCallDetails.screening_calls_detail,
        recruiterCallDetails.screening_calls_detail,
        rawEmailDetails.emails_detail,
        recruiterEmailDetails.emails_detail,
        rawRecruiterDetail?.emails_detail,
        recruiterDetail?.emails_detail
      )

      return {
        recruiterId: rec.recruiter_id,
        recruiterName: rec.recruiter_name,
        recruiterEmail: rec.recruiter_email,

        jobTitles: uniqueJobTitles, // ✅ CLEAN DATA

        createdJobTitles: created,
        handledJobTitles: handled,
        jobsAdded: metrics.jobs_added ?? 0,
        jobsUpdated: metrics.jobs_updated ?? 0,
        totalOpenings: metrics.total_openings ?? 0,
        candidatesAddedDb: metrics.candidates_added_db ?? 0,
        candidatesDetailDb:
          rawCandidateDetails.candidates_detail_db ??
          recruiterCandidateDetails.candidates_detail_db ??
          [],
        candidatesAdded: metrics.candidates_added ?? 0,
        candidatesDetail:
          rawCandidateDetails.candidates_detail ??
          recruiterCandidateDetails.candidates_detail ??
          [],
        shortlistedCount: metrics.shortlisted ?? 0,
        shortlistedDetail:
          rawCandidateDetails.shortlisted_detail ??
          recruiterCandidateDetails.shortlisted_detail ??
          [],
        rejectedCount:
        rawRecruiterDetail?.candidates?.rejected_count ??
        recruiterCandidateDetails?.rejected_count ??
        0,
      rejectedDetail:
        rawCandidateDetails.rejected_detail ??
        recruiterCandidateDetails.rejected_detail ??
        [],
        testsSentCount: metrics.tests_sent ?? 0,
        testsSentDetail:
          rawCallDetails.tests_sent_detail ??
          recruiterCallDetails.tests_sent_detail ??
          [],
        emailsSentCount: metrics.emails_sent ?? 0,
        emailsDetail:
          rawEmailDetails.emails_detail ??
          recruiterEmailDetails.emails_detail ??
          rawRecruiterDetail?.emails_detail ??
          recruiterDetail?.emails_detail ??
          [],
        clickToCallCount: metrics.click_to_call ?? 0,
        clickToCallDetail:
          rawCallDetails.click_to_call_detail ??
          recruiterCallDetails.click_to_call_detail ??
          [],
        screeningCallCount: metrics.screening_calls ?? 0,
        screeningCallDetail:
          rawCallDetails.screening_calls_detail ??
          recruiterCallDetails.screening_calls_detail ??
          [],
        interviewsScheduledCount:
          rawRecruiterDetail?.interviews?.interviews_scheduled_count ??
          recruiterDetail?.interviews?.interviews_scheduled_count ??
          rawRecruiterDetail?.interviews_scheduled_count ??
          recruiterDetail?.interviews_scheduled_count ??
          rawRecruiterDetail?.interviews_created ??
          recruiterDetail?.interviews_created ??
          0,
        interviewsDetail:
          rawRecruiterDetail?.interviews?.scheduled ??
          recruiterDetail?.interviews?.scheduled ??
          rawRecruiterDetail?.interviews_scheduled_detail ??
          recruiterDetail?.interviews_scheduled_detail ??
          rawRecruiterDetail?.interviews?.interviews_detail ??
          recruiterDetail?.interviews?.interviews_detail ??
          rawRecruiterDetail?.interviews?.details ??
          recruiterDetail?.interviews?.details ??
          [],
      }
    })
  }, [topRecruiters, recruiterMetricsMap, recruiterDetails, rawRecruiters])
       const loggedInEmail = userInfos?.user_details?.email || " "
       
       const isRecruiterInList = useMemo(() => {
         if (!loggedInEmail || !detailRows.length) return false
         return detailRows.some(
           row => String(row.recruiterEmail).toLowerCase() === String(loggedInEmail).toLowerCase()
          )
        }, [detailRows, loggedInEmail])
        const isSuperAdmin = !isRecruiterInList 
  const recruiterOptions = useMemo(() => {
  const allOptions = detailRows.map(r => ({
    label: r.recruiterName,
    value: r.recruiterId,
    email: r.recruiterEmail,
  }))

  // 🔒 Recruiter only sees themselves in the dropdown
  if (!isSuperAdmin) {
    return allOptions.filter(opt =>
      String(opt.email).toLowerCase() === String(loggedInEmail).toLowerCase()
    )
  }

  return allOptions
}, [detailRows, isSuperAdmin, loggedInEmail])

// Auto-select the recruiter in dropdown if they are an employee
useEffect(() => {
  if (!isSuperAdmin && recruiterOptions.length > 0) {
    setSelectedRecruiter(String(recruiterOptions[0].value))
  }
}, [isSuperAdmin, recruiterOptions])
  const jobTitleOptions = useMemo(() => {
    let jobs = []

    if (selectedRecruiter) {
      const recruiter = detailRows.find(
        r => String(r.recruiterId) === String(selectedRecruiter)
      )
      jobs = recruiter?.jobTitles || []
    } else {
      jobs = detailRows.flatMap(r => r.jobTitles || [])
    }

    return [...new Map(jobs.map(j => [j.job_id, j])).values()].map(job => ({
      label: job.title,
      value: job.job_id,
    }))
  }, [detailRows, selectedRecruiter])
  useEffect(() => {
    setSelectedJobTitle("")
  }, [selectedRecruiter])
 const filteredRows = useMemo(() => {
  let rows = []

  if (jobStats?.recruiters?.length) {
    rows = jobStats.recruiters
      .filter(r =>
        selectedRecruiter
          ? String(r.recruiter_id) === String(selectedRecruiter)
          : true
      )
      .map(recruiter => {
        const row = mapRecruiterStatsRow(recruiter)
        const reportRow = detailRows.find(
          detail => String(detail.recruiterId) === String(recruiter.recruiter_id)
        )

        return {
          ...row,
          interviewsScheduledCount:
            recruiter?.interviews?.interviews_scheduled_count ??
            recruiter?.interviews_scheduled_count ??
            recruiter?.interviews_created ??
            reportRow?.interviewsScheduledCount ??
            0,
          interviewsDetail:
            recruiter?.interviews?.scheduled ??
            recruiter?.interviews_scheduled_detail ??
            reportRow?.interviewsDetail ??
            [],
        }
      })
  } else {
    rows = detailRows
      .filter(row => {
        const recruiterMatch = selectedRecruiter
          ? String(row.recruiterId) === String(selectedRecruiter)
          : true
        return recruiterMatch
      })
      .map(row => ({
        recruiterId: row.recruiterId,
        recruiterName: row.recruiterName,
        recruiterEmail: row.recruiterEmail,
        jobTitles: row.jobTitles,
        jobsAdded: row.jobsAdded,
        jobsUpdated: row.jobsUpdated,
        totalOpenings: row.totalOpenings,
        candidatesAddedDb: row.candidatesAddedDb,
        candidatesDetailDb: row.candidatesDetailDb,
        candidatesAdded: row.candidatesAdded,
        candidatesDetail: row.candidatesDetail,
        shortlistedCount: row.shortlistedCount,
        shortlistedDetail: row.shortlistedDetail,
        testsSentCount: row.testsSentCount,
        testsSentDetail: row.testsSentDetail,
        emailsSentCount: row.emailsSentCount,
        emailsDetail: row.emailsDetail,
        clickToCallCount: row.clickToCallCount,
        clickToCallDetail: row.clickToCallDetail,
        screeningCallCount: row.screeningCallCount,
        screeningCallDetail: row.screeningCallDetail,
        interviewsScheduledCount: row.interviewsScheduledCount,
        interviewsDetail: row.interviewsDetail,
      }))
  }

  if (!isSuperAdmin) {
    rows = rows.filter(row =>
      String(row.recruiterEmail).toLowerCase() === String(loggedInEmail).toLowerCase()
    )
  }

  return rows
}, [detailRows, selectedRecruiter, selectedJobId, jobStats, isSuperAdmin, loggedInEmail])

  const formatDetailValue = (key, value, item) => {
    if (key.includes("candidate__first_name") || key === "first_name") {
      return getCandidateFullName(item)
    }
    if (
      key === "candidate_name" ||
      key === "job_candidate__candidate_name" ||
      key === "candidate__name"
    ) {
      return getCandidateFullName(item)
    }
    if (
      key === "candidate_email" ||
      key === "job_candidate__candidate_email" ||
      key === "candidate__email" ||
      key === "email"
    ) {
      return getCandidateEmailValue(item)
    }
    if (value === null || value === undefined || value === "") return "-"
    if (key === "panel_members" && Array.isArray(value)) {
      return value
        .map(member => [member.name, member.email].filter(Boolean).join(" - "))
        .join(", ") || "-"
    }
    if (key === "interview_time") {
      const parsed = new Date(value)
      if (!Number.isNaN(parsed.getTime())) {
        const timeZone = item?.time_zone || item?.timezone
        try {
          return new Intl.DateTimeFormat("en-GB", {
            timeZone: timeZone || undefined,
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }).format(parsed)
        } catch (error) {
          return parsed.toLocaleString()
        }
      }
      return String(value)
    }
  if (
    typeof value === "string" &&
    (key.includes("date") || key.includes("at") || key.includes("created"))
  ) {
    const parsed = new Date(value)
    if (!Number.isNaN(parsed.getTime())) {
      let hours = parsed.getHours()
      const minutes = String(parsed.getMinutes()).padStart(2, "0")
      const seconds = String(parsed.getSeconds()).padStart(2, "0")
      const ampm = hours >= 12 ? "PM" : "AM"
      hours = hours % 12
      hours = hours || 12
      const dd = String(parsed.getDate()).padStart(2, "0")
      const mm = String(parsed.getMonth() + 1).padStart(2, "0")
      const yyyy = parsed.getFullYear()
      return `${dd}-${mm}-${yyyy} ${String(hours).padStart(2, "0")}:${minutes}:${seconds} ${ampm}`
    }
  }
    return String(value)
  }
  const MODAL_COLUMNS_WHITELIST = [
    // "id",
    // "job_candidate_id",
    // "job__job_id",
     "_company_name",  
    "job__job_title",
    // "job_candidate__job__job_id",
    "job_candidate__job__job_title",
    "candidate_name",
    "job_candidate__candidate_name",
    "first_name",
    "candidate_email",
    "candidate__email",
    "job_candidate__candidate_email",
    "email",
    "candidate_phone",
    "job_candidate__candidate_phone",
    "mobile_phone",
    "added_from",
    "subject",
    "to_addresses",
    "from_address",
    "created_by_name",
    "applied_date",
    "sent_at",
    "created_at",
    "candidate__first_name",
    "job_title",
    "interview_type",
    "interview_subtype",
    "interview_sub_type",
    "interview_subject",
    "subject",
    "interview_status",
    "status",
    "interview_date",
    "interview_time",
    "interview_date_time",
    "time_zone",
    "timezone",
    "calendar_event_id",
    "event_id",
    // // "candidate__middle_name",
    // "candidate__last_name",
  ]
  const detailModalColumns = useMemo(() => {
    if (!detailModal.rows.length) return []

   const allKeys = new Set(
    detailModal.rows.flatMap(row =>
      Object.keys(row).filter(key => row[key] !== undefined)
    )
  )
  const rowKeys = [...allKeys]
    const prioritizedKeys = MODAL_COLUMNS_WHITELIST.filter(key =>
      rowKeys.includes(key)
    )
    const hiddenColumns = [
      "job_id",
      "job__job_id",
      "id",
      "job_candidate_id",
      "job_candidate__job__job_id",
      "candidate__middle_name",
      "candidate__last_name",
      "middle_name",
      "last_name",
      "candidate_id",
      "email_id",
      "recording_url",
       "company__company_name",
  "job__company_id__company_name",
  "job_candidate__job__company_id__company_name",

"",
    ]
    if (!isAllCompanies) {
  hiddenColumns.push("_company_name")
}

  if (detailModal.title === "Click To Call Details") {
  hiddenColumns.push("secondary_external_call_id", "candidate_status", "stage", "application_status", "", "pipeline_status")
}
if (detailModal.title === "Tests Sent Details") {
  hiddenColumns.push(
    "secondary_external_call_id", 
    "candidate_status", 
    "application_status", 
    "stage",           // ← Added
    "pipeline_status", // ← Added
    "stage_name"       // ← Added
  )
}

    if (detailModal.title === "Screening Call Details") {
      hiddenColumns.push("secondary_external_call_id", "interview_round")
    }

    if (detailModal.title === "Email Sent Details") {
      hiddenColumns.push("stage", "", "candidate_status", "stage_name", "application_status", "")
    }
    if (detailModal.title === "Candidates Added In Database") {
          hiddenColumns.push("stage", "pipeline_status", "candidate_status", "stage_name", "application_status", "")
      }
    if (detailModal.title === "Candidates Added Details") {
          hiddenColumns.push("added_from")
      }

    if (detailModal.title !== "Interviews Scheduled Details") {
      hiddenColumns.push("status")
    }

    const remainingKeys = rowKeys.filter(
      key =>
        !MODAL_COLUMNS_WHITELIST.includes(key) &&
        !hiddenColumns.includes(key)
    )

    const orderedKeys = [...prioritizedKeys, ...remainingKeys].filter(
      key => !hiddenColumns.includes(key)
    )
    const anyRowHasRecordingUrl = detailModal.rows.some(
      row => row.recording_url !== undefined
    )
    if (anyRowHasRecordingUrl && !orderedKeys.includes("recording_url")) {
      orderedKeys.push("recording_url")
    }

    if (detailModal.title === "Interviews Scheduled Details") {
      const interviewColumns = [
        "candidate_name",
        "panel_members",
        "job_title",
        "interview_type",
        "interview_sub_type",
        "subject",
        "status",
        "interview_time",
        "time_zone",
        "calendar_event_id",
      ]

      return interviewColumns.filter(column => rowKeys.includes(column))
    }

    return orderedKeys
  }, [detailModal.rows, detailModal.title])

  const getRecruiterProfileTabRows = tabKey => {
    const tab = RECRUITER_PROFILE_TABS.find(item => item.key === tabKey) || RECRUITER_PROFILE_TABS[0]
    const rows = recruiterProfileModal.row?.[tab.detailKey]
    return Array.isArray(rows)
      ? rows.map(row => ({
          ...row,
          _company_name:
            row?._company_name ||
            row?.company__company_name ||
            row?.job__company_id__company_name ||
            row?.job_candidate__job__company_id__company_name ||
            companyName,
          ...(tabKey === "tests_sent"
            ? {
                candidate_name: getCandidateFullName(row),
                candidate_email: getCandidateEmailValue(row),
              }
            : {}),
          stage:
            row?.stage ||
            row?.pipeline_status ||
            row?.candidate_status ||
            row?.stage_name ||
            row?.application_status ||
            row?.status ||
            "--",
        }))
      : []
  }

  const getRecruiterProfileTabColumns = (tabKey, rows, exportAll = false) => {
    const rowKeys = [
      ...new Set(
        rows.flatMap(row =>
          Object.keys(row).filter(key => row[key] !== undefined && row[key] !== null && row[key] !== "")
        )
      ),
    ]

    const hiddenColumns = [
      "job_id",
      "job__job_id",
      "id",
      "job_candidate_id",
      "job_candidate__job__job_id",
      "candidate__middle_name",
      "candidate__last_name",
      "middle_name",
      "last_name",
      "candidate_id",
      "email_id",
      "recording_url",
      "status",
      "company__company_name",
      "job__company_id__company_name",
      "job_candidate__job__company_id__company_name",
    ]

    if (tabKey === "click_to_call") {
      hiddenColumns.push("secondary_external_call_id", "stage")
    }

    if (tabKey === "candidates_db") {
      hiddenColumns.push("_company_name")
    }

    if (["candidates_db", "tests_sent", "emails"].includes(tabKey)) {
      hiddenColumns.push("stage")
    }

    if (tabKey === "screening") {
      hiddenColumns.push("secondary_external_call_id", "interview_round")
    }
    if (tabKey === "rejected") {
    hiddenColumns.push("secondary_external_call_id")
  }

    const visibleColumns = exportAll
      ? rowKeys.filter(key => !hiddenColumns.includes(key))
      : (() => {
          const allowedKeys = TAB_COLUMNS[tabKey] || []
          const prioritizedKeys = allowedKeys.filter(key => rowKeys.includes(key))
          const remainingKeys = rowKeys.filter(
            key => !allowedKeys.includes(key) && !hiddenColumns.includes(key)
          )
          const orderedKeys = [...prioritizedKeys, ...remainingKeys]
          const hasRecording = rows.some(row => row.recording_url !== undefined)
          if (tabKey !== "click_to_call" && hasRecording && !orderedKeys.includes("recording_url")) {
            orderedKeys.push("recording_url")
          }
          return orderedKeys
        })()

    return dedupeColumnsByHeader(visibleColumns)
  }

  const buildRecruiterProfileExportRows = (tabKey, exportAll = false) => {
    const tab = RECRUITER_PROFILE_TABS.find(item => item.key === tabKey) || RECRUITER_PROFILE_TABS[0]
    const rows = getRecruiterProfileTabRows(tabKey)
    const columns = getRecruiterProfileTabColumns(tabKey, rows, exportAll)

    const data = rows.map(item =>
      columns.reduce((acc, column) => {
        acc[prettifyKey(column)] = formatDetailValue(column, item[column], item)
        return acc
      }, {})
    )

    return { tab, rows, columns, data }
  }

  const buildColoredWorksheet = (workbook, sheetName, data, tab) => {
    const worksheet = workbook.addWorksheet(sheetName.slice(0, 31))
    const columns = Object.keys(data[0] || {})

    worksheet.addRow(columns)
    data.forEach(row => {
      worksheet.addRow(columns.map(column => row[column] ?? ""))
    })

    const headerColor = String(tab?.color || "#2563eb").replace("#", "").toUpperCase()
    const headerRow = worksheet.getRow(1)
    headerRow.eachCell(cell => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: `FF${headerColor}` },
      }
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } }
      cell.alignment = { vertical: "middle", horizontal: "center" }
      cell.border = {
        top: { style: "thin", color: { argb: "FFE2E8F0" } },
        left: { style: "thin", color: { argb: "FFE2E8F0" } },
        bottom: { style: "thin", color: { argb: "FFE2E8F0" } },
        right: { style: "thin", color: { argb: "FFE2E8F0" } },
      }
    })
    headerRow.height = 22

    columns.forEach((column, index) => {
      const maxLength = Math.max(
        column.length,
        ...data.map(row => String(row[column] ?? "").length)
      )
      worksheet.getColumn(index + 1).width = Math.min(Math.max(maxLength + 3, 14), 45)
    })

    return worksheet
  }

  const exportRecruiterProfileTabExcel = async (tabKey, exportAll = false) => {
    const { tab, data } = buildRecruiterProfileExportRows(tabKey, exportAll)
    if (!data.length) {
      Swal.fire({
        icon: "warning",
        title: "No data found",
        text: "There is no data available to export for this tab.",
        confirmButtonText: "OK",
      })
      return
    }

    const workbook = new ExcelJS.Workbook()
    buildColoredWorksheet(workbook, tab.label, data, tab)
    const excelBuffer = await workbook.xlsx.writeBuffer()

    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })

    const suffix = exportAll ? "_All_Columns" : ""
    const fileName = `${sanitizeFileName(recruiterProfileModal.row?.recruiterName || "Recruiter")}_${sanitizeFileName(tab.label)}${suffix}.xlsx`

    saveAs(file, fileName)
  }

  const exportRecruiterProfileAllExcel = async () => {
    const workbook = new ExcelJS.Workbook()
    let sheetCount = 0

    RECRUITER_PROFILE_TABS.filter(tab => tab.key !== "candidates_db").forEach(tab => {
      const { data } = buildRecruiterProfileExportRows(tab.key, true)
      if (!data.length) return

      buildColoredWorksheet(workbook, tab.label, data, tab)
      sheetCount += 1
    })

    if (!sheetCount) {
      Swal.fire({
        icon: "warning",
        title: "No data found",
        text: "There is no data available to export for any tab.",
        confirmButtonText: "OK",
      })
      return
    }

    const excelBuffer = await workbook.xlsx.writeBuffer()

    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })

    const fileName = `${sanitizeFileName(recruiterProfileModal.row?.recruiterName || "Recruiter")}_Activity_Overview_All_Tabs.xlsx`

    saveAs(file, fileName)
  }

  // const openDetailModal = (title, recruiterName, rows) => {
  //   setDetailModal({
  //     open: true,
  //     title,
  //     recruiterName,
  //     rows: Array.isArray(rows) ? rows : [],
  //   })
  // }
const openDetailModal = (title, recruiterName, rows, recruiterId) => {
  const safeRows =
    title === "Interviews Scheduled Details"
      ? normalizeInterviewDetails(rows)
      : Array.isArray(rows)
        ? rows
        : []

  if (!isAllCompanies) {
    setDetailModal({
      open: true,
      title,
      recruiterName,
      rows: safeRows.map(row => ({
        ...row,
        stage:
          row?.stage ||
          row?.pipeline_status ||
          row?.candidate_status ||
          row?.stage_name ||
          row?.application_status ||
          row?.status ||
          "--",
      })),
    })
    return
  }

  // Build a job_id → company_name map from this recruiter's job titles
  const recruiterDetail = recruiterDetails.find(
    d => String(d.recruiter_id) === String(recruiterId)
  )
  const jobCompanyMap = new Map()
  const allJobLists = [
    ...(recruiterDetail?.jobs?.created_job_titles || []),
    ...(recruiterDetail?.jobs?.handled_job_titles || []),
    ...(recruiterDetail?.jobs?.other_activity_job_titles || []),
  ]
  allJobLists.forEach(j => {
    if (j?.job_id && j?.company_name) {
      jobCompanyMap.set(String(j.job_id), j.company_name)
    }
  })

  const rowsWithCompany = safeRows.map(row => {
    const jobId =
      row.job__job_id ||
      row.job_candidate__job__job_id ||
      row.job_id ||
      null

    // 1. Try job_id → company map from recruiter's job titles
    const companyFromJobId = jobId ? jobCompanyMap.get(String(jobId)) : null

    // 2. Fall back to raw API company fields already on the row
    const companyFromRow =
      row.job_candidate__job__company_id__company_name ||
      row.job__company_id__company_name ||
      row.company__company_name ||
      null

    // 3. Fall back to recruiterCompanyMap
    const companyFromRecruiter = recruiterCompanyMap.get(String(recruiterId))

    return {
      ...row,
      _company_name: companyFromJobId || companyFromRow || companyFromRecruiter || companyName,
      stage:
        row?.stage ||
        row?.pipeline_status ||
        row?.candidate_status ||
        row?.stage_name ||
        row?.application_status ||
        row?.status ||
        "--",
    }
  })

  setDetailModal({ open: true, title, recruiterName, rows: rowsWithCompany })
}
  const handleDownloadDetailExcel = () => {
    if (!detailModal.rows.length || !detailModalColumns.length) {
      Swal.fire({
        icon: "warning",
        title: "No data found",
        text: "There is no data available to export.",
        confirmButtonText: "OK",
      })
      return
    }

    const data = detailModal.rows.map(item =>
      detailModalColumns.filter(column => !(detailModal.title === "Click To Call Details" && column === "recording_url")) 
      // Exclude recording_url from Click To Call Details as it can cause issues in Excel and isn't useful there
    .reduce((acc, column) => {
        acc[prettifyKey(column)] = formatDetailValue(column, item[column], item)
        return acc
      }, {})
    )

    const worksheet = XLSX.utils.json_to_sheet(data)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Details")

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    })

    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })

    const fileName = `${sanitizeFileName(detailModal.title)}_${sanitizeFileName(
      detailModal.recruiterName
    )}.xlsx`

    saveAs(file, fileName)
  }
//   const handleDownloadExcel = () => {
//     if (!filteredRows.length) return
//     const workbook = XLSX.utils.book_new()
//     const getCandidateName = candidate =>
//       [
//         candidate.candidate_name,
//         candidate.job_candidate__candidate_name,
//         [candidate.first_name, candidate.middle_name, candidate.last_name]
//           .filter(Boolean)
//           .join(" "),
//       ].find(value => value && String(value).trim()) || "-"

//     const getCandidateEmail = candidate =>
//       candidate.candidate_email ||
//       candidate.job_candidate__candidate_email ||
//       candidate.candidate__email ||
//       candidate.email ||
//       "-"

//     const getCandidatePhone = candidate =>
//       candidate.candidate_phone ||
//       candidate.job_candidate__candidate_phone ||
//       candidate.candidate__mobile_phone ||
//       candidate.mobile_phone ||
//       "-"

//     const getJobId = item =>
//       item.job__job_id || item.job_candidate__job__job_id || item.job_id || "-"

//     const getJobTitle = item =>
//       item.job__job_title ||
//       item.job_candidate__job__job_title ||
//       item.job_title ||
//       "-"

//     const allCandidateData = filteredRows.flatMap(row => {
//       const candidatesDbData = row.candidatesDetailDb.map(candidate => ({
//          Company: companyName,  
//         Recruiter: row.recruiterName,
//         "Recruiter Email": row.recruiterEmail,
//         // Rank: recruiterRankMap.get(String(row.recruiterId)) || "-",
//         // "Detail ID": candidate.candidate_id || "-",
//         // "Job ID": getJobId(candidate),
//         "Job Title": "-",
//         "Candidate Name": getCandidateName(candidate),
//         "Candidate Email": getCandidateEmail(candidate),
//         "Candidate Phone": getCandidatePhone(candidate),
//         Status: candidate.status || "Added",
//         // "Added From": candidate.added_from || "-",
//        "Activity On": formatDateTime(candidate.created_at || candidate.applied_date),
//         Type: "Candidate Added In Database",
//       }))

//       const candidatesData = row.candidatesDetail.map(candidate => ({
//         Company: companyName, 
//         Recruiter: row.recruiterName,
//         "Recruiter Email": row.recruiterEmail,
//         // Rank: recruiterRankMap.get(String(row.recruiterId)) || "-",
//         // "Detail ID": candidate.job_candidate_id || candidate.candidate_id || "-",
//         // "Job ID": getJobId(candidate),
//         "Job Title": getJobTitle(candidate),
//         "Candidate Name": getCandidateName(candidate),
//         "Candidate Email": getCandidateEmail(candidate),
//         "Candidate Phone": getCandidatePhone(candidate),
//         Status: candidate.status || "-",
//         // "Added From": candidate.added_from || "-",
//         "Activity On": formatDateTime(candidate.applied_date || candidate.created_at),
//         Type: "Candidate Added",
//       }))

//       const shortlistedData = row.shortlistedDetail.map(candidate => ({
//         Company: companyName, 
//         Recruiter: row.recruiterName,
//         "Recruiter Email": row.recruiterEmail,
//         // Rank: recruiterRankMap.get(String(row.recruiterId)) || "-",
//         // "Detail ID": candidate.job_candidate_id || candidate.candidate_id || "-",
//         // "Job ID": getJobId(candidate),
//         "Job Title": getJobTitle(candidate),
//         "Candidate Name": getCandidateName(candidate),
//         "Candidate Email": getCandidateEmail(candidate),
//         "Candidate Phone": getCandidatePhone(candidate),
//         Status: candidate.status || "-",
//         // "Added From": candidate.added_from || "-",
//         "Activity On": formatDateTime(candidate.applied_date || candidate.created_at),
//         Type: "Shortlisted",
//       }))

//       const testsSentData = row.testsSentDetail.map(test => ({
//         Company: companyName, 
//         Recruiter: row.recruiterName,
//         "Recruiter Email": row.recruiterEmail,
//         // Rank: recruiterRankMap.get(String(row.recruiterId)) || "-",
//         // "Detail ID": test.id || test.job_candidate_id || "-",
//         // "Job ID": getJobId(test),
//         "Job Title": getJobTitle(test),
//         "Candidate Name": getCandidateName(test),
//         "Candidate Email": getCandidateEmail(test),
//         "Candidate Phone": getCandidatePhone(test),
//         Status: test.status || "-",
//         // "Added From": test.added_from || "-",
//         "Activity On": formatDateTime(test.sent_at || test.created_at),
//         Type: "Test Sent",
//       }))

//       const clickToCallData = row.clickToCallDetail.map(call => ({
//         Company: companyName, 
//         Recruiter: row.recruiterName,
//         "Recruiter Email": row.recruiterEmail,
//         // Rank: recruiterRankMap.get(String(row.recruiterId)) || "-",
//         // "Detail ID": call.id || call.job_candidate_id || "-",
//         // "Job ID": getJobId(call),
//         "Job Title": getJobTitle(call),
//         "Candidate Name": getCandidateName(call),
//         "Candidate Email": getCandidateEmail(call),
//         "Candidate Phone": getCandidatePhone(call),
//         Status: call.status || "-",
//         // "Added From": call.added_from || "-",
//         "Activity On": formatDateTime(call.created_at),
//         Type: "Click To Call",
//       }))

//       const screeningCallData = row.screeningCallDetail.map(call => ({
//         Company: companyName, 
//         Recruiter: row.recruiterName,
//         "Recruiter Email": row.recruiterEmail,
//         // Rank: recruiterRankMap.get(String(row.recruiterId)) || "-",
//         // "Detail ID": call.id || call.job_candidate_id || "-",
//         // "Job ID": getJobId(call),
//         "Job Title": getJobTitle(call),
//         "Candidate Name": getCandidateName(call),
//         "Candidate Email": getCandidateEmail(call),
//         "Candidate Phone": getCandidatePhone(call),
//         Status: call.status || "-",
//         // "Added From": call.added_from || "-",
//         "Activity On": formatDateTime(call.created_at),
//         Type: "Screening Call",
//       }))

//       return [
//         ...candidatesDbData,
//         ...candidatesData,
//         ...shortlistedData,
//         ...testsSentData,
//         ...clickToCallData,
//         ...screeningCallData,
//       ]
//     })

//     // const candidateWorksheet = XLSX.utils.json_to_sheet(allCandidateData)
//     // XLSX.utils.book_append_sheet(workbook, candidateWorksheet, "Candidate Data")
//     const candidateWorksheet = XLSX.utils.json_to_sheet([])
// XLSX.utils.sheet_add_aoa(candidateWorksheet, [[companyName]], { origin: "A1" })
// XLSX.utils.sheet_add_json(candidateWorksheet, allCandidateData, { origin: "A2" })
// XLSX.utils.book_append_sheet(workbook, candidateWorksheet, "Candidate Data")

//     const summaryData = filteredRows.map(row => ({
//       Company: companyName,
//       // Rank: recruiterRankMap.get(String(row.recruiterId)) || "-",
//       // "Recruiter ID": row.recruiterId,
//       Recruiter: row.recruiterName,
//       Email: row.recruiterEmail,
//       "Jobs Added": row.jobsAdded ?? 0,
//       "Jobs Updated": row.jobsUpdated ?? 0,
//       "Total Openings": row.totalOpenings ?? 0,
//       "Job Titles":
//         row.jobTitles
//           ?.map(job => job.title)
//           .filter(Boolean)
//           .join(", ") || "-",
//       "Candidates Added In Database": row.candidatesAddedDb ?? 0,
//       "Candidates Added": row.candidatesAdded ?? 0,
//       "Candidates Added Under the Job": row.candidatesAdded ?? 0,
//       Shortlisted: row.shortlistedCount ?? 0,
//       "Tests Sent": row.testsSentCount ?? 0,
//       "Click To Call": row.clickToCallCount ?? 0,
//       "Screening Calls": row.screeningCallCount ?? 0,
//     }))

//     // const summaryWorksheet = XLSX.utils.json_to_sheet(summaryData)
//     // XLSX.utils.book_append_sheet(
//     //   workbook,
//     //   summaryWorksheet,
//     //   "Recruiter Summary"
//     // )
// const summaryWorksheet = XLSX.utils.json_to_sheet([])
// XLSX.utils.sheet_add_aoa(summaryWorksheet, [[companyName]], { origin: "A1" })
// XLSX.utils.sheet_add_json(summaryWorksheet, summaryData, { origin: "A2" })
// XLSX.utils.book_append_sheet(workbook, summaryWorksheet, "Recruiter Summary")
//     const excelBuffer = XLSX.write(workbook, {
//       bookType: "xlsx",
//       type: "array",
//     })

//     const file = new Blob([excelBuffer], {
//       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//     })

//     // saveAs(file, "Recruiter_Candidate_Data.xlsx")
//     saveAs(file, `${sanitizeFileName(companyName)}_Recruiter_Candidate_Data.xlsx`)
//   }
//   const handleDownloadExcel = async () => {
//   if (!filteredRows.length) return

//   const getCandidateName = candidate =>
//     [
//       candidate.candidate_name,
//       candidate.job_candidate__candidate_name,
//       [candidate.first_name, candidate.middle_name, candidate.last_name]
//         .filter(Boolean)
//         .join(" "),
//     ].find(value => value && String(value).trim()) || "-"

//   const getCandidateEmail = candidate =>
//     candidate.candidate_email ||
//     candidate.job_candidate__candidate_email ||
//     candidate.candidate__email ||
//     candidate.email ||
//     "-"

//   const getCandidatePhone = candidate =>
//     candidate.candidate_phone ||
//     candidate.job_candidate__candidate_phone ||
//     candidate.candidate__mobile_phone ||
//     candidate.mobile_phone ||
//     "-"

//   const getJobTitle = item =>
//     item.job__job_title ||
//     item.job_candidate__job__job_title ||
//     item.job_title ||
//     "-"

//   const allCandidateData = filteredRows.flatMap(row => {
//     const candidatesDbData = row.candidatesDetailDb.map(candidate => ({
//       Company: companyName,
//       Recruiter: row.recruiterName,
//       "Recruiter Email": row.recruiterEmail,
//       "Job Title": "-",
//       "Candidate Name": getCandidateName(candidate),
//       "Candidate Email": getCandidateEmail(candidate),
//       "Candidate Phone": getCandidatePhone(candidate),
//       Status: candidate.status || "Added",
//       "Activity On": formatDateTime(candidate.created_at || candidate.applied_date),
//       Type: "Candidate Added In Database",
//     }))

//     const candidatesData = row.candidatesDetail.map(candidate => ({
//       Company: companyName,
//       Recruiter: row.recruiterName,
//       "Recruiter Email": row.recruiterEmail,
//       "Job Title": getJobTitle(candidate),
//       "Candidate Name": getCandidateName(candidate),
//       "Candidate Email": getCandidateEmail(candidate),
//       "Candidate Phone": getCandidatePhone(candidate),
//       Status: candidate.status || "-",
//       "Activity On": formatDateTime(candidate.applied_date || candidate.created_at),
//       Type: "Candidate Added",
//     }))

//     const shortlistedData = row.shortlistedDetail.map(candidate => ({
//       Company: companyName,
//       Recruiter: row.recruiterName,
//       "Recruiter Email": row.recruiterEmail,
//       "Job Title": getJobTitle(candidate),
//       "Candidate Name": getCandidateName(candidate),
//       "Candidate Email": getCandidateEmail(candidate),
//       "Candidate Phone": getCandidatePhone(candidate),
//       Status: candidate.status || "-",
//       "Activity On": formatDateTime(candidate.applied_date || candidate.created_at),
//       Type: "Shortlisted",
//     }))

//     const testsSentData = row.testsSentDetail.map(test => ({
//       Company: companyName,
//       Recruiter: row.recruiterName,
//       "Recruiter Email": row.recruiterEmail,
//       "Job Title": getJobTitle(test),
//       "Candidate Name": getCandidateName(test),
//       "Candidate Email": getCandidateEmail(test),
//       "Candidate Phone": getCandidatePhone(test),
//       Status: test.status || "-",
//       "Activity On": formatDateTime(test.sent_at || test.created_at),
//       Type: "Test Sent",
//     }))

//     const clickToCallData = row.clickToCallDetail.map(call => ({
//       Company: companyName,
//       Recruiter: row.recruiterName,
//       "Recruiter Email": row.recruiterEmail,
//       "Job Title": getJobTitle(call),
//       "Candidate Name": getCandidateName(call),
//       "Candidate Email": getCandidateEmail(call),
//       "Candidate Phone": getCandidatePhone(call),
//       Status: call.status || "-",
//       "Activity On": formatDateTime(call.created_at),
//       Type: "Click To Call",
//     }))

//     const screeningCallData = row.screeningCallDetail.map(call => ({
//       Company: companyName,
//       Recruiter: row.recruiterName,
//       "Recruiter Email": row.recruiterEmail,
//       "Job Title": getJobTitle(call),
//       "Candidate Name": getCandidateName(call),
//       "Candidate Email": getCandidateEmail(call),
//       "Candidate Phone": getCandidatePhone(call),
//       Status: call.status || "-",
//       "Activity On": formatDateTime(call.created_at),
//       Type: "Screening Call",
//     }))

//     return [
//       ...candidatesDbData,
//       ...candidatesData,
//       ...shortlistedData,
//       ...testsSentData,
//       ...clickToCallData,
//       ...screeningCallData,
//     ]
//   })

//   allCandidateData.sort((a, b) => {
//     const parseDate = str => {
//       if (!str || str === "-") return Infinity
//       const [datePart, timePart] = str.split(" ")
//       const [dd, mm, yyyy] = datePart.split("-")
//       return new Date(`${yyyy}-${mm}-${dd}T${timePart || "00:00:00"}`).getTime()
//     }
//     return parseDate(a["Activity On"]) - parseDate(b["Activity On"])
//   })

//   const summaryData = filteredRows.map(row => ({
//     Company: companyName,
//     Recruiter: row.recruiterName,
//     Email: row.recruiterEmail,
//     "Job Titles": row.jobTitles?.map(job => job.title).filter(Boolean).join(", ") || "-",
//     "Jobs Added": row.jobsAdded ?? 0,
//     "Jobs Updated": row.jobsUpdated ?? 0,
//     "Total Openings": row.totalOpenings ?? 0,
//     "Candidates Added In Database": row.candidatesAddedDb ?? 0,
//     // "Candidates Added": row.candidatesAdded ?? 0,
//     "Candidates Added Under the Job": row.candidatesAdded ?? 0,
//     Shortlisted: row.shortlistedCount ?? 0,
//     "Tests Sent": row.testsSentCount ?? 0,
//     "Click To Call": row.clickToCallCount ?? 0,
//     "Screening Calls": row.screeningCallCount ?? 0,
//   }))

//   const workbook = new ExcelJS.Workbook()

//   const addSheetWithHeader = (sheetName, data) => {
//     if (!data.length) return
//     const sheet = workbook.addWorksheet(sheetName)
//     const columns = Object.keys(data[0])
//     const colCount = columns.length

//     // Row 1: Company name — centered + merged
//     sheet.mergeCells(1, 1, 1, colCount)
//     const titleCell = sheet.getCell("A1")
//     titleCell.value = companyName
//     titleCell.font = { bold: true, size: 13, color: { argb: "FFFFFFFF" } }
//     titleCell.alignment = { horizontal: "center", vertical: "middle" }
//     titleCell.fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: "FF1E40AF" },
//     }
//     sheet.getRow(1).height = 28

//     // Row 2: Column headers — bold + light blue bg
//     const headerRow = sheet.getRow(2)
//     columns.forEach((col, i) => {
//       const cell = headerRow.getCell(i + 1)
//       cell.value = col
//       cell.font = { bold: true, size: 11 }
//       cell.alignment = { horizontal: "center", vertical: "middle" }
//       cell.fill = {
//         type: "pattern",
//         pattern: "solid",
//         fgColor: { argb: "FFD1E8FF" },
//       }
//       cell.border = {
//         bottom: { style: "thin", color: { argb: "FF93C5FD" } },
//       }
//     })
//     headerRow.height = 22

//     // Rows 3+: Data
//     data.forEach(rowData => {
//       const row = sheet.addRow(columns.map(col => rowData[col]))
//       row.alignment = { vertical: "middle" }
//     })

//     // Auto column width
//     columns.forEach((col, i) => {
//       const maxLen = Math.max(
//         col.length,
//         ...data.map(r => String(r[col] ?? "").length)
//       )
//       sheet.getColumn(i + 1).width = Math.min(Math.max(maxLen + 4, 14), 50)
//     })
//   }

//   addSheetWithHeader("Candidate Data", allCandidateData)
//   addSheetWithHeader("Recruiter Summary", summaryData)

//   const buffer = await workbook.xlsx.writeBuffer()
//   const file = new Blob([buffer], {
//     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   })
//   saveAs(file, `${sanitizeFileName(companyName)}_Recruiter_Candidate_Data.xlsx`)
// }
// Build a per-recruiter company name map from API data
const recruiterCompanyMap = useMemo(() => new Map(
  (reportData?.recruiter_details || []).map(r => {
    // Check direct company_name on recruiter first
    if (r?.company_name) return [String(r.recruiter_id), r.company_name]

    // Then check job titles
    const allJobs = [
      ...(r?.jobs?.created_job_titles || []),
      ...(r?.jobs?.handled_job_titles || []),
      ...(r?.jobs?.other_activity_job_titles || []),
    ]
    const nameFromJobs = allJobs.find(j => j?.company_name)?.company_name

    if (nameFromJobs) return [String(r.recruiter_id), nameFromJobs]

    // Check session storage for this specific company_id
    const nameFromSession = userInfos?.user_details?.companies_data?.find(
      c => String(c.company_id) === String(r.company_id)
    )?.company_name

    return [String(r.recruiter_id), nameFromSession || "Unknown Company"]
  })
), [reportData, userInfos])

const getCompany = (recruiterId) =>
  recruiterCompanyMap.get(String(recruiterId)) || companyName
const handleDownloadExcel = async () => {
  if (!filteredRows.length) return

  const getCandidateName = candidate =>
    getCandidateFullName(candidate)

  const getCandidateEmail = candidate =>
    candidate.candidate_email ||
    candidate.job_candidate__candidate_email ||
    candidate.candidate__email ||
    candidate.email ||
    "-"

  const getCandidatePhone = candidate =>
    candidate.candidate_phone ||
    candidate.job_candidate__candidate_phone ||
    candidate.candidate__mobile_phone ||
    candidate.mobile_phone ||
    "-"

  const getJobTitle = item =>
    item.job__job_title ||
    item.job_candidate__job__job_title ||
    item.job_title ||
    "-"
    const getRecordingUrl = (item) => {
    const url = item.recording_url;
    return url ? getRecordingPlayUrl(url) : "-";
  };

  const allCandidateData = filteredRows.flatMap(row => {
    const candidatesDbData = row.candidatesDetailDb.map(candidate => ({
      Company: getCompany(row.recruiterId),
      Recruiter: row.recruiterName,
      "Recruiter Email": row.recruiterEmail,
      "Job Title": "-",
      "Candidate Name": getCandidateName(candidate),
      "Candidate Email": getCandidateEmail(candidate),
      "Candidate Phone": getCandidatePhone(candidate),
      Status: candidate.status || "Added",
      "Activity On": formatDateTime(candidate.created_at || candidate.applied_date),
      Type: "Candidate Added In Database",
    }))

    const candidatesData = row.candidatesDetail.map(candidate => ({
      Company: getCompany(row.recruiterId),
      Recruiter: row.recruiterName,
      "Recruiter Email": row.recruiterEmail,
      "Job Title": getJobTitle(candidate),
      "Candidate Name": getCandidateName(candidate),
      "Candidate Email": getCandidateEmail(candidate),
      "Candidate Phone": getCandidatePhone(candidate),
      Status: candidate.status || "-",
      "Activity On": formatDateTime(candidate.applied_date || candidate.created_at),
      Type: "Candidate Added",
    }))

    const shortlistedData = row.shortlistedDetail.map(candidate => ({
      Company: getCompany(row.recruiterId),
      Recruiter: row.recruiterName,
      "Recruiter Email": row.recruiterEmail,
      "Job Title": getJobTitle(candidate),
      "Candidate Name": getCandidateName(candidate),
      "Candidate Email": getCandidateEmail(candidate),
      "Candidate Phone": getCandidatePhone(candidate),
      Status: candidate.status || "-",
      "Activity On": formatDateTime(candidate.applied_date || candidate.created_at),
      Type: "Shortlisted",
    }))

    const testsSentData = row.testsSentDetail.map(test => ({
      Company: getCompany(row.recruiterId),
      Recruiter: row.recruiterName,
      "Recruiter Email": row.recruiterEmail,
      "Job Title": getJobTitle(test),
      "Candidate Name": getCandidateName(test),
      "Candidate Email": getCandidateEmail(test),
      "Candidate Phone": getCandidatePhone(test),
      Status: test.status || "-",
      "Activity On": formatDateTime(test.sent_at || test.created_at),
      Type: "Test Sent",
    }))

    const emailsSentData = (row.emailsDetail || []).map(email => ({
      Company: getCompany(row.recruiterId),
      Recruiter: row.recruiterName,
      "Recruiter Email": row.recruiterEmail,
      "Job Title": getJobTitle(email),
      "Candidate Name":
        email.job_candidate__candidate_name ||
        email.candidate_name ||
        email.created_by_name ||
        "-",
      "Candidate Email":
        email.job_candidate__candidate_email ||
        email.candidate_email ||
        email.to_addresses ||
        "-",
      "Candidate Phone": email.from_address || "-",
      Status: email.subject || "-",
      "Activity On": formatDateTime(email.created_at || email.sent_at),
      Type: "Email Sent",
    }))

    const clickToCallData = row.clickToCallDetail.map(call => ({
      Company: getCompany(row.recruiterId),
      Recruiter: row.recruiterName,
      "Recruiter Email": row.recruiterEmail,
      "Job Title": getJobTitle(call),
      "Candidate Name": getCandidateName(call),
      "Candidate Email": getCandidateEmail(call),
      "Candidate Phone": getCandidatePhone(call),
      Status: call.status || "-",
      "Activity On": formatDateTime(call.created_at),
      Type: "Click To Call",
      // "Recording URL": getRecordingUrl(call),
   }))

    const screeningCallData = row.screeningCallDetail.map(call => ({
      Company: getCompany(row.recruiterId),
      Recruiter: row.recruiterName,
      "Recruiter Email": row.recruiterEmail,
      "Job Title": getJobTitle(call),
      "Candidate Name": getCandidateName(call),
      "Candidate Email": getCandidateEmail(call),
      "Candidate Phone": getCandidatePhone(call),
      Status: call.status || "-",
      "Activity On": formatDateTime(call.created_at),
      Type: "Screening Call",
    }))

    return [
      ...candidatesDbData,
      ...candidatesData,
      ...shortlistedData,
      ...testsSentData,
      ...emailsSentData,
      ...clickToCallData,
      ...screeningCallData,
    ]
  })

  allCandidateData.sort((a, b) => {
    const parseDate = str => {
      if (!str || str === "-") return Infinity
      const [datePart, timePart] = str.split(" ")
      const [dd, mm, yyyy] = datePart.split("-")
      return new Date(`${yyyy}-${mm}-${dd}T${timePart || "00:00:00"}`).getTime()
    }
    return parseDate(a["Activity On"]) - parseDate(b["Activity On"])
  })

  const exportRows = detailRows.filter(row =>
    selectedRecruiter
      ? String(row.recruiterId) === String(selectedRecruiter)
      : true
  )

  // const summaryData = exportRows.map(row => ({
  //   Company: companyName,
  //   Recruiter: row.recruiterName,
  //   Email: row.recruiterEmail,
  //   "Job Titles": row.jobTitles?.map(job => job.title).filter(Boolean).join(", ") || "-",
  //   "Jobs Added": row.jobsAdded ?? 0,
  //   "Jobs Updated": row.jobsUpdated ?? 0,
  //   "Total Openings": row.totalOpenings ?? 0,
  //   "Candidates Added In Database": row.candidatesAddedDb ?? 0,
  //   "Candidates Added Under the Job": row.candidatesAdded ?? 0,
  //   Shortlisted: row.shortlistedCount ?? 0,
  //   "Tests Sent": row.testsSentCount ?? 0,
  //   "Click To Call": row.clickToCallCount ?? 0,
  //   "Screening Calls": row.screeningCallCount ?? 0,
  // }))
const summaryData = (() => {
  const allRows = []

  exportRows.forEach(row => {
    const createdTitles = row.createdJobTitles || []
    const handledTitles = row.handledJobTitles || []
    const otherActivityTitles = recruiterDetails.find(
      d => String(d.recruiter_id) === String(row.recruiterId)
    )?.jobs?.other_activity_job_titles || []

    // ✅ Exclude from handled any job that already appears in created
    const createdJobIds = new Set(createdTitles.map(j => String(j.job_id)))
    const filteredHandledTitles = handledTitles.filter(
      j => !createdJobIds.has(String(j.job_id))
    )

    // --- Created Jobs rows ---
    createdTitles.forEach(job => {
      allRows.push({
        Company: getCompany(row.recruiterId),
        Recruiter: row.recruiterName,
        Email: row.recruiterEmail,
        "Job Type": "Created",
        "Job Title": job.job_title || job.title || "-",
        "Total Openings": job.total_openings ?? 0,
        "Candidates Added Under the Job": job.candidates_added ?? 0,
        Shortlisted: job.shortlisted_count ?? 0,
        Rejected: job.rejected_count ?? 0,
        "Tests Sent": job.tests_sent_count ?? 0,
        "Email Sent": job.emails_sent_count ?? 0,
        "Click To Call": job.click_to_call_count ?? 0,
        "Screening Calls": job.screening_calls_count ?? 0,
      })
    })

    // --- Handled Jobs rows (deduplicated) ---
    filteredHandledTitles.forEach(job => {
      allRows.push({
        Company: getCompany(row.recruiterId),
        Recruiter: row.recruiterName,
        Email: row.recruiterEmail,
        "Job Type": "Handled",
        "Job Title": job.job_title || job.title || "-",
        "Total Openings": job.total_openings ?? 0,
        "Candidates Added Under the Job": job.candidates_added ?? 0,
        Shortlisted: job.shortlisted_count ?? 0,
        Rejected: job.rejected_count ?? 0,
        "Tests Sent": job.tests_sent_count ?? 0,
        "Email Sent": job.emails_sent_count ?? 0,
        "Click To Call": job.click_to_call_count ?? 0,
        "Screening Calls": job.screening_calls_count ?? 0,
      })
    })

    // --- Other Activity Jobs rows ---
    otherActivityTitles.forEach(job => {
      allRows.push({
        Company: getCompany(row.recruiterId),
        Recruiter: row.recruiterName,
        Email: row.recruiterEmail,
        "Job Type": "Other Activity",
        "Job Title": job.job_title || job.title || "-",
        "Total Openings": job.total_openings ?? 0,
        "Candidates Added Under the Job": job.candidates_added ?? 0,
        Shortlisted: job.shortlisted_count ?? 0,
        Rejected: job.rejected_count ?? 0,
        "Tests Sent": job.tests_sent_count ?? 0,
        "Email Sent": job.emails_sent_count ?? 0,
        "Click To Call": job.click_to_call_count ?? 0,
        "Screening Calls": job.screening_calls_count ?? 0,
      })
    })

    // --- Per-recruiter subtotal row ---
    const sf = (arr, f) => (arr || []).reduce((a, j) => a + (j[f] ?? 0), 0)

    allRows.push({
      Company: getCompany(row.recruiterId),
      Recruiter: row.recruiterName,
      Email: row.recruiterEmail,
      "Job Type": `SUBTOTAL — Jobs Created: ${createdTitles.length} | Jobs Handled: ${filteredHandledTitles.length} | Other Activity: ${otherActivityTitles.length}`,
      "Job Title": "— Recruiter Total —",
      "Total Openings": sf(createdTitles, "total_openings") + sf(filteredHandledTitles, "total_openings") + sf(otherActivityTitles, "total_openings"),
      "Candidates Added Under the Job": sf(createdTitles, "candidates_added") + sf(filteredHandledTitles, "candidates_added") + sf(otherActivityTitles, "candidates_added"),
      Shortlisted: sf(createdTitles, "shortlisted_count") + sf(filteredHandledTitles, "shortlisted_count") + sf(otherActivityTitles, "shortlisted_count"),
      // Rejected: sf(createdTitles, "rejected_count") + sf(filteredHandledTitles, "rejected_count") + sf(otherActivityTitles, "rejected_count"),
      Rejected: row.rejectedCount ?? 0,   
      "Tests Sent": sf(createdTitles, "tests_sent_count") + sf(filteredHandledTitles, "tests_sent_count") + sf(otherActivityTitles, "tests_sent_count"),
      // In the subtotal push inside summaryData:
        "Email Sent": sf(createdTitles, "emails_sent_count") + sf(filteredHandledTitles, "emails_sent_count") + sf(otherActivityTitles, "emails_sent_count"),
      "Click To Call": sf(createdTitles, "click_to_call_count") + sf(filteredHandledTitles, "click_to_call_count") + sf(otherActivityTitles, "click_to_call_count"),
      "Screening Calls": sf(createdTitles, "screening_calls_count") + sf(filteredHandledTitles, "screening_calls_count") + sf(otherActivityTitles, "screening_calls_count"),
    })
  })

  return allRows
})()
  const overallSummaryData = exportRows.flatMap(row => {
    const createdJobs = buildJobTitleList(row.createdJobTitles || [])
    const handledJobs = buildJobTitleList(row.handledJobTitles || [])
    const allJobs = buildJobTitleList(
      row.jobTitles || [],
      createdJobs,
      handledJobs,
      row.candidatesDetail || [],
      row.shortlistedDetail || [],
      row.testsSentDetail || [],
      row.clickToCallDetail || [],
      row.screeningCallDetail || []
    )

    const createdJobKeys = new Set(
      createdJobs
        .map(job => getNormalizedJobTitleKey(job.title || getJobKey(job)))
        .filter(Boolean)
    )
    const jobMetrics = new Map()

    const ensureJobMetrics = job => {
      const jobKey =
        getNormalizedJobTitleKey(job?.title || getJobKey(job)) ||
        String(job?.title || "").trim()
      if (!jobKey) return null

      if (!jobMetrics.has(jobKey)) {
        jobMetrics.set(jobKey, {
          job_id: job.job_id,
          title: job.title,
          jobsAdded: createdJobKeys.has(jobKey) ? 1 : 0,
          candidatesAddedDb: 0,
          candidatesAdded: 0,
          shortlisted: 0,
          testsSent: 0,
          emailsSent: toNumber(job?.emails_sent_count),
          clickToCall: 0,
          screeningCalls: 0,
        })
      }

      return jobMetrics.get(jobKey)
    }

    const bumpMetric = (items, field) => {
      ;(Array.isArray(items) ? items : []).forEach(item => {
        const job = getJobDescriptor(item)
        const metrics = job ? ensureJobMetrics(job) : null
        if (metrics) {
          metrics[field] += 1
        }
      })
    }

    const uniqueJobs = [...new Map(
      allJobs
        .map(job => {
          const title = String(job?.title || "").trim()
          const normalizedKey = getNormalizedJobTitleKey(title || getJobKey(job))
          if (!normalizedKey) return null

          return [
            normalizedKey,
            {
              job_id: job.job_id || normalizedKey,
              title,
            },
          ]
        })
        .filter(Boolean)
    ).values()]

    bumpMetric(row.candidatesDetailDb, "candidatesAddedDb")
    bumpMetric(row.candidatesDetail, "candidatesAdded")
    bumpMetric(row.shortlistedDetail, "shortlisted")
    bumpMetric(row.testsSentDetail, "testsSent")
    bumpMetric(row.clickToCallDetail, "clickToCall")
    bumpMetric(row.screeningCallDetail, "screeningCalls")

    const totalRow = {
      Company: companyName,
      Recruiter: row.recruiterName,
      "Recruiter Email": row.recruiterEmail,
      "Row Type": "Recruiter Total",
      "Job Title": "All jobs",
      "Jobs Handled": row.jobTitles?.length ?? 0,
      "Jobs Added": row.jobsAdded ?? 0,
      "Jobs Updated": row.jobsUpdated ?? 0,
      "Total Openings": row.totalOpenings ?? 0,
      "Candidates Added In Database": row.candidatesAddedDb ?? 0,
      "Candidates Added Under the Job": row.candidatesAdded ?? 0,
      Shortlisted: row.shortlistedCount ?? 0,
      Rejected: row.rejectedCount ?? 0,
      "Tests Sent": row.testsSentCount ?? 0,
      "Email Sent": row.emailsSentCount ?? 0,
      "Click To Call": row.clickToCallCount ?? 0,
      "Screening Calls": row.screeningCallCount ?? 0,
      "Interviews Scheduled": row.interviewsScheduledCount ?? 0,
    }

    const jobRows = uniqueJobs.map(job => {
      const jobKey = getNormalizedJobTitleKey(job.title || job.job_id)
      const metrics = jobKey ? jobMetrics.get(jobKey) : null

      return {
        Company: companyName,
        Recruiter: row.recruiterName,
        "Recruiter Email": row.recruiterEmail,
        "Row Type": "Job Detail",
        "Job Title": job.title,
        "Jobs Handled": 1,
        // "Jobs Added": metrics?.jobsAdded ?? (createdJobKeys.has(jobKey) ? 1 : 0),
        "Jobs Updated": 0,
        "Total Openings": 0,
        "Candidates Added In Database": metrics?.candidatesAddedDb ?? 0,
        "Candidates Added Under the Job": metrics?.candidatesAdded ?? 0,
        Shortlisted: metrics?.shortlisted ?? 0,
        Rejected: metrics?.rejected ?? 0,
        "Tests Sent": metrics?.testsSent ?? 0,
        "Email Sent": metrics?.emailsSent ?? 0,
        "Click To Call": metrics?.clickToCall ?? 0,
        "Screening Calls": metrics?.screeningCalls ?? 0,
      }
    })

    return [totalRow, ...jobRows]
  })
  const workbook = new ExcelJS.Workbook()

  const formatHeaderDate = dateStr => {
    if (!dateStr) return "All time"
    const date = new Date(dateStr)
    if (Number.isNaN(date.getTime())) return dateStr
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
  }

  const startDateLabel = formatHeaderDate(reportStartDate)
  const endDateLabel = formatHeaderDate(reportEndDate)
const headerText = isAllCompanies
  ? `Report for All Companies from ${startDateLabel} to ${endDateLabel}`
  : `Report for ${companyName} from ${startDateLabel} to ${endDateLabel}`

  const addSheetWithHeader = (sheetName, data) => {
    if (!data.length) return
    const sheet = workbook.addWorksheet(sheetName)
    const columns = Object.keys(data[0])
    const colCount = columns.length

    sheet.mergeCells(1, 1, 1, colCount)
    const titleCell = sheet.getCell("A1")
    titleCell.value = headerText
    titleCell.font = { bold: true, size: 14, color: { argb: "FFFFFFFF" } }
    titleCell.alignment = { horizontal: "center", vertical: "middle", wrapText: true }
    titleCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF1E40AF" },
    }
    sheet.getRow(1).height = 32

    // Row 2: Column headers — bold + light blue bg
    const headerRow = sheet.getRow(2)
    columns.forEach((col, i) => {
      const cell = headerRow.getCell(i + 1)
      cell.value = col
      cell.font = { bold: true, size: 11 }
      cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true }
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFD1E8FF" },
      }
      cell.border = {
        bottom: { style: "thin", color: { argb: "FF93C5FD" } },
      }
    })
    headerRow.height = 22

    // Rows 3+: Data
    data.forEach((rowData, rowIdx) => {
      const isSubtotal = String(rowData["Job Title"] || "").includes("— Recruiter Total —")
      const isGrandTotal = rowData["Recruiter"] === "GRAND TOTAL"
      const row = sheet.addRow(columns.map(col => rowData[col]))
      row.alignment = { vertical: "middle", wrapText: true }

      if (isGrandTotal) {
        row.eachCell(cell => {
          cell.font = { bold: true, size: 11, color: { argb: "FFFFFFFF" } }
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1E40AF" } }
          cell.alignment = { horizontal: "center", vertical: "middle" }
        })
        row.height = 26
      } else if (isSubtotal) {
        row.eachCell(cell => {
          cell.font = { bold: true, size: 10, color: { argb: "FF1E3A8A" } }
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD1E8FF" } }
          cell.alignment = { horizontal: "left", vertical: "middle" }
        })
        row.height = 22
      }
    columns.forEach((col, index) => {
    if (
      col === "Recording URL" &&
      rowData[col] &&
      rowData[col] !== "-"
    ) {
      const cell = row.getCell(index + 1)

      cell.value = {
        text: "Play Recording",
        hyperlink: rowData[col],
      }

      cell.font = {
        color: { argb: "FF0000FF" },
        underline: true,
      }
    }
  })
    })

    // Auto column width
    columns.forEach((col, i) => {
      const maxLen = Math.max(
        col.length,
        ...data.map(r => String(r[col] ?? "").length)
      )
      sheet.getColumn(i + 1).width = Math.min(Math.max(maxLen + 2, 14), 50)
    })
  }

  addSheetWithHeader("Candidate Data", allCandidateData)
  addSheetWithHeader("Recruiter Summary", summaryData)
  // Build Overall Data sheet — one row per recruiter with key headline metrics
 const overallDataRows = (() => {
  const rawRecruiterMap = new Map(
    rawRecruiters.map(r => [String(r.recruiter_id), r])
  )

  const dataRows = exportRows.map(row => {
    const rawRecruiter = rawRecruiterMap.get(String(row.recruiterId))

    const createdTitles = row.createdJobTitles || []
    const handledTitles = row.handledJobTitles || []
    const otherActivityTitles = recruiterDetails.find(
      d => String(d.recruiter_id) === String(row.recruiterId)
    )?.jobs?.other_activity_job_titles || []

    // Same deduplication logic as summaryData
    const createdJobIds = new Set(createdTitles.map(j => String(j.job_id)))
    const filteredHandledTitles = handledTitles.filter(
      j => !createdJobIds.has(String(j.job_id))
    )

    const sf = (arr, f) => (arr || []).reduce((a, j) => a + (j[f] ?? 0), 0)

    // Sum metrics across all job types — matches the subtotal row in summaryData
    const totalOpenings =
      sf(createdTitles, "total_openings") +
      sf(filteredHandledTitles, "total_openings") +
      sf(otherActivityTitles, "total_openings")

    const candidatesAddedUnderJob =
      sf(createdTitles, "candidates_added") +
      sf(filteredHandledTitles, "candidates_added") +
      sf(otherActivityTitles, "candidates_added")

    const shortlisted =
      sf(createdTitles, "shortlisted_count") +
      sf(filteredHandledTitles, "shortlisted_count") +
      sf(otherActivityTitles, "shortlisted_count")

    const testsSent =
      sf(createdTitles, "tests_sent_count") +
      sf(filteredHandledTitles, "tests_sent_count") +
      sf(otherActivityTitles, "tests_sent_count")

    const clickToCall =
      sf(createdTitles, "click_to_call_count") +
      sf(filteredHandledTitles, "click_to_call_count") +
      sf(otherActivityTitles, "click_to_call_count")

    const screeningCalls =
      sf(createdTitles, "screening_calls_count") +
      sf(filteredHandledTitles, "screening_calls_count") +
      sf(otherActivityTitles, "screening_calls_count")
      

    // candidatesAddedDb from rawRecruiters (same as UI table)
    // const candidatesAddedDb = recruiterMetricsMap.get(String(row.recruiterId))?.candidates_added_db ?? 0


    // emailsSent from row (same as subtotal row in summaryData)
   const emailsSent =
  sf(createdTitles, "emails_sent_count") +
  sf(filteredHandledTitles, "emails_sent_count") +
  sf(otherActivityTitles, "emails_sent_count")

    return {
      Company: getCompany(row.recruiterId),
      "Recruiter Name": row.recruiterName,
      "Recruiter Email": row.recruiterEmail,
      // "Jobs Created": createdTitles.length,
      "Jobs Handled": filteredHandledTitles.length,
      // "Other Activity Jobs": otherActivityTitles.length,
      // "Total Openings": totalOpenings,
      // "Candidates Added in Database": candidatesAddedDb,
      "Candidates Added Under the Job": candidatesAddedUnderJob,
      Shortlisted: shortlisted,
      Rejected: row.rejectedCount ?? 0,
      "Tests Sent": testsSent,
      "Email Sent": emailsSent,
      "Click To Call": clickToCall,
      "Screening Calls": screeningCalls,
    }
  })

  const totalRow = {
    Company: isAllCompanies ? "All Companies" : companyName,
    "Recruiter Name": "GRAND TOTAL",
    "Recruiter Email": `${dataRows.length} recruiter${dataRows.length === 1 ? "" : "s"}`,
    // "Jobs Created": dataRows.reduce((s, r) => s + (r["Jobs Created"] ?? 0), 0),
    "Jobs Handled": dataRows.reduce((s, r) => s + (r["Jobs Handled"] ?? 0), 0),
    // "Other Activity Jobs": dataRows.reduce((s, r) => s + (r["Other Activity Jobs"] ?? 0), 0),
    "Total Openings": dataRows.reduce((s, r) => s + (r["Total Openings"] ?? 0), 0),
    "Candidates Added in Database": dataRows.reduce((s, r) => s + (r["Candidates Added in Database"] ?? 0), 0),
    "Candidates Added Under the Job": dataRows.reduce((s, r) => s + (r["Candidates Added Under the Job"] ?? 0), 0),
    Shortlisted: dataRows.reduce((s, r) => s + (r["Shortlisted"] ?? 0), 0),
    Rejected: dataRows.reduce((s, r) => s + (r["Rejected"] ?? 0), 0),
    "Tests Sent": dataRows.reduce((s, r) => s + (r["Tests Sent"] ?? 0), 0),
    "Email Sent": dataRows.reduce((s, r) => s + (r["Email Sent"] ?? 0), 0),
    "Click To Call": dataRows.reduce((s, r) => s + (r["Click To Call"] ?? 0), 0),
    "Screening Calls": dataRows.reduce((s, r) => s + (r["Screening Calls"] ?? 0), 0),
  }

  return [...dataRows, totalRow]
})()

  addSheetWithHeader("Overall Data", overallDataRows)
  // addSheetWithHeader("Overall Summary", overallSummaryData)

  const buffer = await workbook.xlsx.writeBuffer()
  const file = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  })
  saveAs(file, `${sanitizeFileName(companyName)}_Recruiter_Candidate_Data.xlsx`)
}
  const maxLeaderboardMetric = useMemo(() => {
    return Math.max(
      ...topRecruiters.map(recruiter =>
        Math.max(
          toNumber(recruiter?.jobs_added),
          toNumber(recruiter?.candidates_added),
          toNumber(recruiter?.shortlisted),
          toNumber(recruiter?.tests_sent),
          toNumber(getEmailsSentCount(recruiter)),
          toNumber(recruiter?.screening_calls)
        )
      ),
      1
    )
  }, [topRecruiters])
  const fetchJobStats = async () => {
    try {
      setDetailsLoading(true)

      const params = {
        job_id: selectedJobId,
      }

      if (selectedRecruiter) {
        params.recruiter_id = selectedRecruiter
      }

      if (detailsStartDate) params.date_from = detailsStartDate
      if (detailsEndDate) params.date_to = detailsEndDate

      const res = await axios.get(
        `/api/v1/company/${companyId}/recruiter-job-stats/`,
        { params }
      )

      setJobStats(res.data)
    } catch (err) {
      console.error("Job stats error:", err)
      setJobStats(null)
    } finally {
      setDetailsLoading(false)
    }
  }
  useEffect(() => {
    fetchJobStats()
  }, [
    selectedJobId,
    selectedRecruiter,
    companyId,
    detailsStartDate,
    detailsEndDate,
  ])

  const summaryCards = [
    {
      label: "Active Recruiters",
      value: toNumber(companySummary?.active_recruiters),
      accent: "#2563eb",
      bg: "#eff6ff",
      icon: FaUsers,
    },
    {
      label: "Jobs Added",
      value: toNumber(companySummary?.total_jobs_added),
      accent: "#0f766e",
      bg: "#ecfdf5",
      icon: FaBriefcase,
    },
    {
      label: "Candidates Added",
      value: toNumber(companySummary?.total_candidates_added),
      accent: "#7c3aed",
      bg: "#f5f3ff",
      icon: FaUserCheck,
    },
    {
      label: "Tests Sent",
      value: toNumber(companySummary?.total_tests_sent),
      accent: "#db2777",
      bg: "#fdf2f8",
      icon: FaClipboardCheck,
    },
    {
      label: "Screening Calls",
      value: toNumber(companySummary?.total_screening_calls),
      accent: "#0891b2",
      bg: "#ecfeff",
      icon: FaPhoneAlt,
    },
    {
      label: "Shortlisted",
      value: toNumber(companySummary?.total_shortlisted),
      accent: "#d97706",
      bg: "#fff7ed",
      icon: FaCheckCircle,
    },
    {
      label: "Rejected",
      value: toNumber(companySummary?.total_rejected ?? companySummary?.total_declined),
      accent: "#ef4444",
      bg: "#fff1f2",
      icon: FaTimes,
    },
  ]
  const scopeLabel =
    reportStartDate || reportEndDate
      ? `${reportStartDate ? formatDateLabel(reportStartDate) : "Start"} - ${
          reportEndDate ? formatDateLabel(reportEndDate) : "Today"
        }`
      : "All time"
  return (
    <div className="container-fluid recruiter-report-page">
      <div
        className="recruiter-report-hero"
        style={{
          padding: "28px 35px",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "14px",
          flexWrap: "wrap",
        }}
      >
        <div className="recruiter-report-hero-orb recruiter-report-hero-orb-one" />
        <div className="recruiter-report-hero-orb recruiter-report-hero-orb-two" />
        <div
          className="recruiter-report-hero-copy"
          style={{
            gap: "8px",
            flex: "1 1 auto",
            display: "flex",
            alignItems: "flex-start",
          }}
        >
          <div
            style={{
              width: "48px",
              height: "48px",
              borderRadius: "16px",
              background: "rgba(255,255,255,0.14)",
              border: "1px solid rgba(255,255,255,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              flexShrink: 0,
              boxShadow: "0 10px 25px rgba(15, 23, 42, 0.12)",
            }}
          >
            <FaUsers size={18} />
          </div>
          <div style={{ minWidth: 0, flex: 1 }}>
            <div
              className="recruiter-report-eyebrow"
              style={{
                marginBottom: "4px",
                fontSize: "0.68rem",
                padding: "5px 10px",
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              Job Order Analytics
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
                marginBottom: "3px",
              }}
            >
              <h4
                className="mb-0 recruiter-report-title"
                style={{ fontSize: "1.2rem", lineHeight: 1.1 }}
              >
                Recruiter Activity Report
              </h4>
            </div>
            <div
              className="recruiter-report-subtitle"
              style={{
                fontSize: "0.740rem",
                maxWidth: "680px",
                lineHeight: 1.35,
              }}
            >
              Company-wide recruiter activity across jobs, candidates, tests,
              and screening calls.
            </div>
          </div>
        </div>
        <div
          style={{
            flex: "0 0 auto",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-end",
            gap: "12px",
            flexWrap: "nowrap",
            padding: "0",
            marginLeft: "auto",
            alignSelf: "flex-start",
          }}
        >
          <div
            style={{
              flex: "0 1 260px",
              minWidth: "200px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <label
              className="recruiter-report-filter-label"
              style={{ color: "#dbeafe", marginBottom: "6px" }}
            >
              Select Company
            </label>
            <CompanySelector
              showAllOption
              onCompanyChange={company =>
                setCompanyId(
                  String(company?.company_id).toLowerCase() === "all"
                    ? "all"
                    : company?.company_id ?? null
                )
              }
              selectedCompanyId={
                String(companyId).toLowerCase() === "all" ? "All" : companyId
              }
              className="form-select mb-0"
            />
          </div>
          <div
            style={{
              flex: "0 1 210px",
              minWidth: "180px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <label
              className="recruiter-report-filter-label"
              style={{ color: "#dbeafe", marginBottom: "6px" }}
            >
              From Date
            </label>
            <input
              type="date"
             className="form-control recruiter-report-filter-input"
              value={reportStartDate}
              max={reportEndDate || undefined}
              onChange={e => handleStartDateChange(e.target.value)}
              style={{
                background: "rgba(255,255,255,0.92)",
                border: "1px solid rgba(191, 219, 254, 0.7)",
              }}
            />
          </div>
          <div
            style={{
              flex: "0 1 210px",
              minWidth: "180px",
             display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <label
              className="recruiter-report-filter-label"
              style={{ color: "#dbeafe", marginBottom: "6px" }}
            >
              To Date
            </label>
            <input
              type="date"
              className="form-control recruiter-report-filter-input"
              value={reportEndDate}
              min={reportStartDate || undefined}
              onChange={e => handleEndDateChange(e.target.value)}
              style={{
                background: "rgba(255,255,255,0.92)",
                border: "1px solid rgba(191, 219, 254, 0.7)",
              }}
            />
          </div>
          <div>
            <label
              className="recruiter-report-filter-label invisible"
              style={{ color: "#dbeafe", fontSize: "6px" }}
            >
              Btn
           </label>

            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                gap: "10px",
                flexWrap: "nowrap",
                marginLeft: "0",
                whiteSpace: "nowrap",
              }}
            >
              <button
                type="button"
                className="btn recruiter-report-filter-reset"
                onClick={() => {
                  syncDateFilters({ start: "", end: "" })
                }}
                style={{ minWidth: "128px", height: "42px" }}
              >
                Clear Filters
              </button>
              <button
                type="button"
                className="btn recruiter-report-filter-reset"
                onClick={() => {
                  const today = getTodayFormatted()
                  syncDateFilters({ start: today, end: today })
                }}
                style={{
                  minWidth: "128px",
                  height: "42px",
                  background: "#eff6ff",
                  color: "#1e3a8a",
                }}
              >
                Reset Filters
              </button>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="recruiter-report-loading">
          <OrgTableShimmer columns={5} rows={6} titleWidth="220px" />
        </div>
      ) : error ? (
        <div className="recruiter-report-error">{error}</div>
      ) : (
        <>
        {isSuperAdmin && (
          <div className="recruiter-report-summary-grid">
            {summaryCards.map(card => {
              const CardIcon = card.icon
              return (
                <div
                  key={card.label}
                  className="recruiter-summary-card"
                  style={{
                    background: card.bg,
                    border: `1px solid ${card.accent}22`,
                    borderTop: `4px solid ${card.accent}`,
                  }}
                >
                  <div className="recruiter-summary-card-inner">
                    <div>
                      <div
                        className="recruiter-summary-value"
                        style={{
                          color: card.accent,
                          fontSize: "1.35rem",
                          fontWeight: 500,
                        }}
                      >
                        {card.value}
                      </div>
                      <div
                        className="recruiter-summary-label"
                        style={{
                          fontSize: "0.88rem",
                          fontWeight: 500,
                          color: "#475569",
                        }}
                      >
                        {card.label}
                      </div>
                    </div>
                    <div
                      className="recruiter-summary-accent"
                      style={{
                        background: `${card.accent}14`,
                        border: `1px solid ${card.accent}22`,
                        width: "42px",
                        height: "42px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: card.accent,
                      }}
                    >
                      <CardIcon size={16} />
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
      )}
          <Row className="g-3 mb-3">
            <Col lg={12} md={12} sm={12} className="d-none">
              <div className="recruiter-panel recruiter-panel-full">
                <div className="recruiter-panel-header">
                  <div>
                    <div className="recruiter-panel-title">
                      Recruiter Performance
                    </div>
                    <div className="recruiter-panel-subtitle">
                      Ranked directly from the recruiter activity response
                    </div>
                  </div>
                </div>
                <div className="recruiter-snapshot-list">
                  <Row className="g-3">
                    {topRecruiters.length ? (
                      topRecruiters.map(recruiter => {
                        const spotlightValue = Math.max(
                          toNumber(recruiter?.jobs_added),
                          toNumber(recruiter?.candidates_added),
                          toNumber(recruiter?.shortlisted),
                          toNumber(recruiter?.tests_sent),
                          toNumber(getEmailsSentCount(recruiter)),
                          toNumber(recruiter?.screening_calls)
                        )
                        return (
                          <Col
                            key={recruiter.recruiter_id}
                            lg={3}
                            md={6}
                            sm={12}
                          >
                            <div className="recruiter-snapshot-card">
                              <div className="recruiter-avatar">
                                {getInitials(recruiter?.recruiter_name)}
                              </div>
                              <div className="recruiter-snapshot-main">
                                <div
                                  className="recruiter-snapshot-name"
                                  style={{
                                    fontWeight: 600,
                                    fontSize: "0.98rem",
                                  }}
                                >
                                  {recruiter?.recruiter_name ||
                                    "Unknown Recruiter"}
                                </div>
                                <div
                                  className="recruiter-snapshot-email"
                                  style={{ fontSize: "0.82rem" }}
                                >
                                  {recruiter?.recruiter_email || "-"}
                                </div>
                                <div
                                  className="recruiter-snapshot-meta"
                                  style={{
                                    fontSize: "0.82rem",
                                    fontWeight: 500,
                                  }}
                                >
                                  {toNumber(recruiter?.jobs_added)} jobs,{" "}
                                  {toNumber(recruiter?.candidates_added)}{" "}
                                  candidates, {toNumber(recruiter?.shortlisted)}{" "}
                                  shortlisted
                                </div>
                                <div className="recruiter-progress-track">
                                  <div
                                    className="recruiter-progress-bar"
                                    style={{
                                      width: `${
                                        (spotlightValue /
                                          maxLeaderboardMetric) *
                                        100
                                      }%`,
                                    }}
                                  />
                                </div>
                                <div className="recruiter-snapshot-tags">
                                  <span className="recruiter-inline-chip recruiter-inline-chip-pink">
                                    {toNumber(recruiter?.tests_sent)} tests
                                  </span>
                                  <span className="recruiter-inline-chip recruiter-inline-chip-violet">
                                    {toNumber(getEmailsSentCount(recruiter))}{" "}emails
                                  </span>
                                  <span className="recruiter-inline-chip recruiter-inline-chip-blue">
                                   {toNumber(recruiter?.click_to_call)}{" "}
                                    click-to-call
                                  </span>
                                  <span className="recruiter-inline-chip recruiter-inline-chip-teal">
                                    {toNumber(recruiter?.screening_calls)}{" "}
                                    screening
                                  </span>
                                </div>
                              </div>
                            </div>
                          </Col>
                        )
                      })
                    ) : (
                      <div className="recruiter-empty-state">
                        No recruiter leaderboard data found.
                      </div>
                    )}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
          <div className="recruiter-breakdown-panel">
            <div className="recruiter-breakdown-header d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div>
                <div className="recruiter-panel-title">
                  Recruiter Activity Details
                </div>
                <div className="recruiter-breakdown-subtitle">
                  Job, candidate, and call metrics for each recruiter from the
                  same report response.
                </div>
              </div>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                {/* <input
                  type="date"
                  className="form-control"
                  style={{ width: "150px" }}
                  value={detailsStartDate}
                  max={detailsEndDate || undefined}
                  onChange={e => handleStartDateChange(e.target.value)}
                />
                <input
                  type="date"
                  className="form-control"
                  style={{ width: "150px" }}
                  value={detailsEndDate}
                  min={detailsStartDate || undefined}
                  onChange={e => handleEndDateChange(e.target.value)}
                /> */}
                <select
                  className="form-control"
                  style={{ width: "180px" }}
                  value={selectedRecruiter}
                  onChange={e => setSelectedRecruiter(e.target.value)}
                >
                  <option value="">Select Recruiter</option>
                  {recruiterOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
                <select
                  className="form-control"
                  style={{ width: "180px" }}
                  value={selectedJobId}
                  onChange={e => setSelectedJobId(e.target.value)}
                >
                  <option value="">Select Job Title</option>
                  {jobTitleOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>

                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setSelectedRecruiter("")
                    setSelectedJobId("")
                    setSelectedJobTitle("")
                    syncDateFilters({ start: "", end: "" })
                  }}
                >
                  Clear
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    const today = getTodayFormatted()
                    syncDateFilters({ start: today, end: today })
                  }}
                >
                  Reset
                </button>
                {/* <button
                  className="btn btn-success"
                  onClick={handleDownloadExcel}
                >
                  Excel
                </button> */}
                <button
                  className="btn btn-success"
                  style={{ background: "#0f766e", borderColor: "#0f766e" }}
                  onClick={async () => {
                    setExcelDownloading(true)
                    try {
                      const params = {}
                      if (reportStartDate) params.date_from = reportStartDate
                      if (reportEndDate) params.date_to = reportEndDate
                      if (selectedRecruiter) params.recruiter_id = selectedRecruiter

                      const response = await axios.get(
                        `/api/v1/company/${companyId}/recruiter-performance/download/`,
                        {
                          params,
                          responseType: "blob",
                        }
                      )

                      const contentDisposition = response.headers["content-disposition"]
                      let fileName = `${sanitizeFileName(companyName)}_Recruiter_Performance.xlsx`
                      if (contentDisposition) {
                        const match = contentDisposition.match(/filename[^;=\n]*=["']?([^"'\n;]+)["']?/)
                        if (match?.[1]) fileName = match[1].trim()
                      }

                      const blob = new Blob([response.data], {
                        type: response.headers["content-type"] ||
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                      })

                      saveAs(blob, fileName)
                    } catch (err) {
                      console.error("BE Excel download failed:", err)
                      Swal.fire({
                        icon: "error",
                        title: "Download Failed",
                        text: err?.response?.data?.message || "Failed to download the report. Please try again.",
                        confirmButtonText: "OK",
                      })
                    }
                    finally {
                      setExcelDownloading(false)
                    }
                  }}
                >
                  {excelDownloading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          />
                          Downloading...
                        </>
                      ) : (
                        "Excel"
                      )}
                </button>
              </div>
            </div>
            <div className="recruiter-breakdown-table-wrap mt-3">
              {detailsLoading ? (
                <div style={{ padding: "6px 0" }}>
                  <OrgTableShimmer columns={7} rows={4} titleWidth="180px" />
                </div>
              ) : (
                <table
                  className="recruiter-breakdown-table"
                  style={{ minWidth: 1320 }}
                >
                  <thead>
                    <tr>
                      {[
                        "Recruiter",
                        "Interviews Scheduled",
                        // "Candidates Added in the Database",
                        "Candidates Added Under the Job",
                        "Shortlisted",
                        "Rejected",
                        "Tests Sent",
                        "Email Sent",
                        "Click To Call",
                        "Screening Calls",
                      ].map(head => (
                        <th key={head} className="text-center">
                          {head}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredRows.length ? (
                      filteredRows.map((row, index) => (
                        <tr
                          key={row.recruiterId || row.recruiterName}
                          className={index % 2 === 0 ? "" : "is-alt"}
                        >
                          <td style={tdStyle}>
                            <div className="recruiter-table-person">
                              <div>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setRecruiterProfileTab("candidates_added")
                                    setRecruiterProfileModal({ open: true, row })
                                  }}
                                  style={{
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    color: "#2563eb",
                                    fontWeight: 600,
                                    fontSize: "0.875rem",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    textDecorationColor: "#93c5fd",
                                    textUnderlineOffset: "3px",
                                    transition: "color 0.15s",
                                  }}
                                  onMouseEnter={e => (e.currentTarget.style.color = "#1d4ed8")}
                                  onMouseLeave={e => (e.currentTarget.style.color = "#2563eb")}
                                >
                                  {row.recruiterName}
                                </button>
                                <div className="recruiter-table-email">
                                  {row.recruiterEmail || "No email available"}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td style={tdStyle}>
                            <div className="d-flex align-items-center justify-content-center gap-2">
                              <span className="recruiter-chip recruiter-chip-blue">
                                {row.interviewsScheduledCount}
                              </span>
                              <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none"
                                aria-label={
                                  row.interviewsDetail?.length
                                    ? "View interview details"
                                    : "No data available"
                                }
                                onClick={() =>
                                  openDetailModal(
                                    "Interviews Scheduled Details",
                                    row.recruiterName,
                                    row.interviewsDetail,
                                    row.recruiterId
                                  )
                                }
                              >
                                <FaEye size={14} />
                              </button>
                            </div>
                          </td>
                          {/* <td style={tdStyle}>
                            <div className="d-flex align-items-center justify-content-center gap-2">
                              <span>{row.candidatesAddedDb}</span>
                              <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none"
                                title={
                                  row.candidatesDetailDb?.length
                                    ? "View candidate details"
                                    : "No data available"
                                }
                                // disabled={!row.candidatesDetail?.length}
                                // style={{
                                //   opacity: row.candidatesDetail?.length ? 1 : 0.4,
                                //   cursor: row.candidatesDetail?.length ? "pointer" : "not-allowed",
                                // }}
                                onClick={() => openDetailModal("Candidates Added In Database", row.recruiterName, row.candidatesDetailDb, row.recruiterId)}

                              >
                                <FaEye />
                              </button>
                            </div>
                          </td> */}
                          <td style={tdStyle}>
                            <div className="d-flex align-items-center justify-content-center gap-2">
                              <span>{row.candidatesAdded}</span>
                              <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none"
                                aria-label={
                                  row.candidatesDetail?.length
                                    ? "View candidate details"
                                    : "No data available"
                                }
                                // disabled={!row.candidatesDetail?.length}
                                // style={{
                                //   opacity: row.candidatesDetail?.length ? 1 : 0.4,
                                //   cursor: row.candidatesDetail?.length ? "pointer" : "not-allowed",
                                // }}
                                  onClick={() =>
                                    openDetailModal(
                                      "Candidates Added Details",
                                      row.recruiterName,
                                      row.candidatesDetail
                                    )
                                }
                              >
                                <FaEye />
                              </button>
                            </div>
                          </td>
                          <td style={tdStyle}>
                            <div className="d-flex align-items-center justify-content-center gap-2">
                              <span className="recruiter-chip recruiter-chip-pink">
                                {row.shortlistedCount}
                              </span>
                              <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none"
                                aria-label={
                                  row.shortlistedDetail?.length
                                    ? "View shortlisted details"
                                    : "No data available"
                                }
                                // disabled={!row.shortlistedDetail?.length}
                                onClick={() => openDetailModal("Shortlisted Details", row.recruiterName, row.shortlistedDetail, row.recruiterId)}

                              >
                                <FaEye size={14} />
                              </button>
                            </div>
                          </td>
                          <td style={tdStyle}>
                            <div className="d-flex align-items-center justify-content-center gap-2">
                              <span className="recruiter-chip recruiter-chip-pink">
                                {row.rejectedCount}
                              </span>
                              <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none"
                                aria-label={
                                  row.rejectedDetail?.length
                                    ? "View rejected details"
                                    : "No data available"
                                }
                                // disabled={!row.rejectedDetail?.length}
                                onClick={() => openDetailModal("Rejected Details", row.recruiterName, row.rejectedDetail, row.recruiterId)}

                              >
                                <FaEye size={14} />
                              </button>
                            </div>
                          </td>
                          <td style={tdStyle}>
                            <div className="d-flex align-items-center justify-content-center gap-2">
                              <span className="recruiter-chip recruiter-chip-violet">
                                {row.testsSentCount}
                              </span>
                              <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none"
                                aria-label={
                                  row.testsSentDetail?.length
                                    ? "View tests sent details"
                                    : "No data available"
                                }
                                // disabled={!row.testsSentDetail?.length}
                                onClick={() => openDetailModal("Tests Sent Details", row.recruiterName, row.testsSentDetail, row.recruiterId)}


                              >
                                <FaEye size={14} />
                              </button>
                            </div>
                          </td>
                          <td style={tdStyle}>
                            <div className="d-flex align-items-center justify-content-center gap-2">
                              <span className="recruiter-chip recruiter-chip-blue">
                                {row.emailsSentCount}
                              </span>
                              <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none"
                                aria-label={
                                  row.emailsDetail?.length
                                    ? "View email details"
                                    : "No data available"
                                }
                                onClick={() => openDetailModal("Email Sent Details", row.recruiterName, row.emailsDetail, row.recruiterId)}

                              >
                                <FaEye size={14} />
                              </button>
                            </div>
                          </td>
                          <td style={tdStyle}>
                            <div className="d-flex align-items-center justify-content-center gap-2">
                              <span className="recruiter-chip recruiter-chip-teal">
                                {row.clickToCallCount}
                              </span>
                              <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none"
                                aria-label={
                                  row.clickToCallDetail?.length
                                    ? "View click to call details"
                                    : "No data available"
                                }
                                // disabled={!row.clickToCallDetail?.length}
                               onClick={() => openDetailModal("Click To Call Details", row.recruiterName, row.clickToCallDetail, row.recruiterId)}

                              >
                                <FaEye size={14} />
                              </button>
                            </div>
                          </td>
                          <td style={tdStyle}>
                            <div className="d-flex align-items-center justify-content-center gap-2">
                              <span className="recruiter-chip recruiter-chip-green">
                                {row.screeningCallCount}
                              </span>
                              <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none"
                                aria-label={
                                  row.screeningCallDetail?.length
                                    ? "View screening call details"
                                    : "No data available"
                                }
                                // disabled={!row.screeningCallDetail?.length}
                               onClick={() => openDetailModal("Screening Call Details", row.recruiterName, row.screeningCallDetail, row.recruiterId)}

                              >
                                <FaEye size={14} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9} className="recruiter-empty-table">
                          No recruiter activity details available.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
          <Modal
            isOpen={detailModal.open}
            toggle={() =>
              setDetailModal(prev => ({ ...prev, open: false, rows: [] }))
            }
            size="xl"
            centered
            className="recruiter-detail-modal"
            style={{ width: "96vw", maxWidth: "1600px" }}
          >
            <ModalHeader
              toggle={() =>
                setDetailModal(prev => ({ ...prev, open: false, rows: [] }))
              }
              className="border-0 recruiter-detail-modal-header"
            >
              <div className="recruiter-detail-modal-header-row" style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
                <div className="recruiter-detail-modal-heading" style={{ flex: "1 1 auto", minWidth: 0 }}>
                  <div className="recruiter-detail-modal-title">
                    {detailModal.title}
                  </div>
                  <div className="recruiter-detail-modal-meta">
                    <span>{detailModal.recruiterName || "Recruiter"}</span>
                    <span className="recruiter-detail-modal-dot" />
                    <span className="recruiter-detail-modal-count">
                      {detailModal.rows.length} record
                      {detailModal.rows.length === 1 ? "" : "s"}
                    </span>
                  </div>
                </div>
                <div className="recruiter-detail-modal-actions" s style={{ 
                position: "absolute",
                right: "78px",  // 52px leaves room for the × close button
                top: "50%",
                transform: "translateY(-50%)",
              }}>
                  <button
        type="button"
        className="btn recruiter-detail-modal-export"
        onClick={handleDownloadDetailExcel}
        disabled={!detailModal.rows.length}
        style={{
          background: "linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%)",
          color: "#fff",
          border: "none",
          boxShadow: "0 10px 24px rgba(29, 78, 216, 0.28)",
          padding: "9px 15px",
          fontWeight: 800,
          letterSpacing: "0.01em",
          minWidth: "144px",
          height: "42px",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          borderRadius: "10px",
          flexShrink: 0,
          marginRight: "8px", // gap before the × close button
        }}
      >
        <FaDownload /> Export Excel
      </button>
                </div>
              </div>
            </ModalHeader>
            {/* <ModalBody className="recruiter-detail-modal-body">
              {detailModal.rows.length ? (
                <div className="table-responsive recruiter-detail-modal-table-wrap" >
                  <table className="table mb-0 align-middle recruiter-detail-modal-table" style={{ maxWidth: "90vw" }}>
                    <thead>
                      <tr>
                        {detailModalColumns.map(column => (
                          <th
                            key={column}
                            style={{
                              whiteSpace: "nowrap",
                              width: "300px",
                              color: "#334155",
                              borderBottom: "1px solid #dbeafe",
                              borderRight: "1px solid #f0e2e2",
                              // minWidth: column === "job__job_title" || column === "job_candidate__job__job_title" ? "100px" : "120px",
                            }}
                          >
                            {prettifyKey(column)}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                    {detailModal.rows.map((item, index) => (
                      <tr key={item.id || item.job_candidate_id || index}>
                        {detailModalColumns.map(column => (
                          <td
                            key={`${index}-${column}`}
                            style={{
                              fontSize: "0.88rem",
                              color: "#475569",
                              whiteSpace: "nowrap",
                              borderRight: "1px solid #f1f5f9",
                              minWidth: column === "job__job_title" || column === "job_candidate__job__job_title" ? "200px" : "120px",
                            }}
                          >
                            {column === "candidate__first_name"
                                ? `${item.candidate__first_name || ""} ${item.candidate__middle_name || ""} ${item.candidate__last_name || ""}`.trim()
                                : formatDetailValue(column, item[column], item)}
                         </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                  </table>
                </div>
              ) : (
                <div className="recruiter-detail-modal-empty">
                  No  data available.
                </div>
              )}
            </ModalBody> */}
            <ModalBody className="recruiter-detail-modal-body">
              {detailModal.rows.length ? (
                <div
                  className="table-responsive recruiter-detail-modal-table-wrap "
                  style={{ overflowX: "auto" }}
                >
                  <table
                    className="table mb-0 align-middle recruiter-detail-modal-table sticky-header"
                    style={{ width: "100%", tableLayout: "fixed" }}
                  >
                    <thead>
                      {/* <tr>
                        <th
                          colSpan={detailModalColumns.length}
                         style={{
                            background: "#1e40af",
                            color: "#fff",
                            textAlign: "center",
                            fontSize: "0.82rem",
                            fontWeight: 600,
                            padding: "6px 12px",
                            letterSpacing: "0.03em",
                            borderBottom: "2px solid #1e3a8a",
                          }}
                        >
                          {companyName}
                        </th>
                      </tr> */}
                      <tr>
                        {detailModalColumns.map(column => (
                          <th
                            key={column}
                            style={{
                              whiteSpace: "normal",
                              minWidth: column.includes("job_title")
                                ? "300px"
                                : "150px",
                              maxWidth: column.includes("job_title")
                                ? "400px"
                                : "200px",
                              wordBreak: "break-word",
                              borderBottom: "1px solid #dbeafe",
                              borderRight: "1px solid #f0e2e2",
                            }}
                          >
                            {prettifyKey(column)}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {detailModal.rows.map((item, index) => (
                        <tr key={item.id || item.job_candidate_id || index}>
                          {detailModalColumns.map(column => (
                            <td
                              key={`${index}-${column}`}
                              style={{
                                fontSize: "0.88rem",
                                color: "#475569",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                borderRight: "1px solid #f1f5f9",
                                minWidth: column.includes("job_title")
                                  ? "300px"
                                  : "150px",
                            maxWidth: column.includes("job_title")
                              ? "400px"
                              : "200px",
                          }}
                        >
                             {detailModal.title === "Interviews Scheduled Details" && column === "candidate_name" ? (
                                item.candidate_names?.length ? (
                                  item.candidate_names.map((name, candidateIndex) => (
                                    <div key={`${name}-${candidateIndex}`}>{name}</div>
                                  ))
                                ) : "-"
                              ) : detailModal.title === "Interviews Scheduled Details" && column === "panel_members" ? (
                                item.panel_members?.length ? (
                                  item.panel_members.map((member, memberIndex) => (
                                    <div key={member.email || `${member.name}-${memberIndex}`}>
                                      {[member.name, member.email].filter(Boolean).join(" - ") || "-"}
                                    </div>
                                  ))
                                ) : "-"
                              ) : column === "recording_url" && item[column] ? (
                                <RecordingPlayer
                                  src={getRecordingPlayUrl(item[column])}
                                  currentPlayingRef={currentPlayingRef}
                                />
                              ) : detailModal.title === "Screening Call Details" && column === "created_at" ? (
                                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                                  <span>{formatDetailValue(column, item[column], item)}</span>
                                  {item.secondary_external_call_id ? (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-primary"
                                      style={{ fontSize: 11, padding: "3px 10px", width: "fit-content" }}
                                      onClick={() => {
                                        // console.info("View Transcript clicked", item);
                                        handleViewCallTranscript(item);
                                      }}
                                    >
                                      View Transcript
                                    </button>
                                  ) : (
                                    <span style={{ fontSize: 11, color: "#94a3b8" }}>
                                      No transcript
                                    </span>
                                  )}
                                </div>
                              ) : (
                                formatDetailValue(column, item[column], item)
                              )}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="recruiter-detail-modal-empty">
                  No data available.
                </div>
              )}
            </ModalBody>
          </Modal>
           <style>{screeningModalStyles}</style>
                    <Modal
                      isOpen={screeningModal}
                      toggle={() => setScreeningModal(false)}
                      size="lg"
                      centered
                      className="screening-modal"
                      backdrop="static"
                    >
                      <ModalHeader
                        toggle={() => setScreeningModal(false)}
                        className="border-0"
                        style={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", color: "#fff", padding: "18px 24px" }}
                      >
                        <div className="d-flex align-items-center gap-2" style={{ fontSize: 18, fontWeight: 600, color: "#fff" }}>
                          <div style={{ width: 34, height: 34, borderRadius: 8, background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", backdropFilter: "blur(4px)" }}>
                            <Phone size={18} />
                          </div>
                          {screeningType} Result
                          {screeningData && !screeningError && (
                            <span style={{ fontSize: 11, fontWeight: 500, marginLeft: 8, background: "rgba(255,255,255,0.2)", color: "#fff", padding: "2px 10px", borderRadius: 20, display: "inline-flex", alignItems: "center", gap: 4 }}>
                              <Sparkles size={12} />AI Screening
                            </span>
                          )}
                        </div>
                      </ModalHeader>
          
                      <ModalBody style={{ padding: 0, maxHeight: "75vh", overflowY: "auto" }} className="screening-transcript-container">
                        {screeningLoading ? (
                          <div className="text-center py-5" style={{ animation: "fadeIn 0.3s ease" }}>
                            <div style={{ width: 60, height: 60, borderRadius: "50%", background: "linear-gradient(135deg, #667eea, #764ba2)", display: "inline-flex", alignItems: "center", justifyContent: "center", animation: "pulse 1.5s ease infinite", marginBottom: 16 }}>
                              <Phone size={28} style={{ color: "#fff" }} />
                            </div>
                            <h6 className="text-muted mb-1">Loading screening results...</h6>
                            <div className="mx-auto mt-3" style={{ width: 200, height: 4, borderRadius: 2, background: "#e5e7eb", overflow: "hidden" }}>
                              <div style={{ width: "40%", height: "100%", borderRadius: 2, background: "linear-gradient(90deg, #667eea, #764ba2, #667eea)", backgroundSize: "200% 100%", animation: "shimmer 1.5s ease infinite" }} />
                            </div>
                          </div>
                        ) : screeningError ? (
                          <div className="text-center py-5 px-3" style={{ animation: "fadeInUp 0.4s ease" }}>
                            <div style={{ width: 90, height: 90, borderRadius: "50%", background: "linear-gradient(135deg, #fef2f2, #fee2e2)", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 20, boxShadow: "0 8px 24px rgba(220,53,69,0.15)" }}>
                              <Phone size={40} style={{ color: "#dc3545" }} />
                            </div>
                            <h5 className="text-danger mb-2" style={{ fontWeight: 600 }}>{screeningError}</h5>
                          </div>
                        ) : screeningData ? (
                          <>
                            {/* Candidate & Agent Info */}
                            <div style={{ background: "linear-gradient(180deg, #f8f9ff 0%, #fff 100%)", padding: "24px 28px 16px", animation: "fadeIn 0.4s ease" }}>
                              <Row>
                                <Col md={6}>
                                  <div className="d-flex align-items-center gap-3 mb-3 screening-avatar-candidate" style={{ animation: "slideInLeft 0.5s ease forwards" }}>
                                    <div style={{ width: 52, height: 52, borderRadius: "50%", background: "linear-gradient(135deg, #667eea, #764ba2)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 22, fontWeight: 700, flexShrink: 0, boxShadow: "0 4px 14px rgba(102,126,234,0.4)" }}>
                                      {(screeningData.candidate_name || "C")[0].toUpperCase()}
                                    </div>
                                    <div>
                                      <h6 className="mb-0" style={{ fontWeight: 700, fontSize: 15 }}>{capitalizeFirst(screeningData.candidate_name)}</h6>
                                      <small className="text-muted" style={{ fontSize: 12 }}>{capitalizeFirst(screeningData.designation || screeningData.job_title)}</small>
                                    </div>
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <div className="d-flex align-items-center gap-3 mb-3 screening-avatar-candidate" style={{ animation: "slideInRight 0.5s ease forwards" }}>
                                    <div style={{ width: 52, height: 52, borderRadius: "50%", background: "linear-gradient(135deg, #f093fb, #f5576c)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", flexShrink: 0, boxShadow: "0 4px 14px rgba(240,147,251,0.4)" }}>
                                      <Bot size={24} />
                                    </div>
                                    <div>
                                      <h6 className="mb-0" style={{ fontWeight: 700, fontSize: 15 }}>{capitalizeFirst(screeningData.agent_name)}</h6>
                                      <small style={{ fontSize: 12, color: "#f5576c" }}>AI Recruiter</small>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                {[
                                  { icon: <Phone size={16} />, label: "Phone", value: screeningData.candidate_phone, color: "#0d6efd", bg: "#eff6ff" },
                                  { icon: <Briefcase size={16} />, label: "Job Title", value: capitalizeFirst(screeningData.job_title), color: "#059669", bg: "#ecfdf5" },
                                  { icon: <Calendar size={16} />, label: "Interview Date & Time", value: screeningData.date_of_interview && screeningData.date_of_interview !== "-" ? formatDateTime(screeningData.date_of_interview) : "-", color: "#7c3aed", bg: "#f5f3ff" },
                                ].map((item, idx) => (
                                  <Col md={4} key={idx}>
                                    <div className="d-flex align-items-center gap-2 mb-3 screening-info-card" style={{ background: "#fff", borderRadius: 10, padding: "12px 14px", border: "1px solid #f0f0f0", animation: `fadeInUp 0.4s ease ${0.1 * (idx + 1)}s forwards`, opacity: 0 }}>
                                      <div style={{ width: 34, height: 34, borderRadius: 8, background: item.bg, display: "flex", alignItems: "center", justifyContent: "center", color: item.color, flexShrink: 0 }}>
                                        {item.icon}
                                      </div>
                                      <div style={{ minWidth: 0 }}>
                                        <div style={{ fontSize: 10, color: "#9ca3af", textTransform: "uppercase", letterSpacing: 0.8, fontWeight: 600 }}>{item.label}</div>
                                        <div style={{ fontSize: 13, fontWeight: 600, color: "#1f2937", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.value || "-"}</div>
                                      </div>
                                    </div>
                                  </Col>
                                ))}
                              </Row>
                            </div>
          
                            <div style={{ padding: "8px 28px 28px" }}>
                              {/* Section Scores */}
                              {screeningData?.sections &&
 Object.keys(screeningData?.sections).length > 0 && (
                                <div className="mb-4 screening-section" style={{ animationDelay: "0.15s" }}>
                                  {screeningData?.overall_score !== null && (
                                    <div className="d-flex align-items-center gap-3 mb-3 p-3" style={{ background: "linear-gradient(135deg, #eff6ff, #dbeafe)", borderRadius: 12, border: "1px solid #bfdbfe" }}>
                                      <div style={{ width: 56, height: 56, borderRadius: "50%", background: "linear-gradient(135deg, #3b82f6, #2563eb)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 20, fontWeight: 800, flexShrink: 0, boxShadow: "0 4px 14px rgba(59,130,246,0.4)" }}>
                                        {screeningData.overall_score}
                                      </div>
                                      <div>
                                        <div style={{ fontSize: 11, color: "#6b7280", textTransform: "uppercase", letterSpacing: 0.8, fontWeight: 600 }}>Overall Score</div>
                                        <div style={{ fontSize: 14, fontWeight: 700, color: "#1e40af" }}>{screeningData.overall_score}/10</div>
                                      </div>
                                    </div>
                                  )}
                                  <h6 className="d-flex align-items-center gap-2 mb-3" style={{ fontWeight: 700, color: "#374151", fontSize: 14 }}>
                                    <div style={{ width: 30, height: 30, borderRadius: 8, background: "linear-gradient(135deg, #fef3c7, #fde68a)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                      <Star size={16} style={{ color: "#d97706" }} />
                                    </div>
                                    Evaluation Sections
                                  </h6>
                                  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                                    {Object.entries(screeningData.sections).map(([key, section], idx) => (
                                      <div key={key} className="screening-question-item" style={{ background: "#fff", borderRadius: 12, padding: "16px 18px", border: "1px solid #e5e7eb", animation: `fadeInUp 0.3s ease ${0.05 * idx}s forwards`, opacity: 0 }}>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                          <span style={{ fontSize: 14, fontWeight: 700, color: "#1f2937" }}>{section.section_name || key}</span>
                                          <span style={{ fontSize: 12, fontWeight: 700, background: section.score >= 8 ? "#059669" : section.score >= 6 ? "#d97706" : "#dc2626", color: "#fff", padding: "2px 10px", borderRadius: 20 }}>{section.score}/10</span>
                                        </div>
                                        <div style={{ width: "100%", height: 6, borderRadius: 3, background: "#e5e7eb", marginBottom: 10 }}>
                                          <div style={{ width: `${(section.score / 10) * 100}%`, height: "100%", borderRadius: 3, background: section.score >= 8 ? "linear-gradient(90deg, #34d399, #059669)" : section.score >= 6 ? "linear-gradient(90deg, #fbbf24, #d97706)" : "linear-gradient(90deg, #f87171, #dc2626)", transition: "width 0.5s ease" }} />
                                        </div>
                                        {section.feedback && <p className="mb-1" style={{ fontSize: 12, color: "#4b5563", lineHeight: 1.5 }}>{section.feedback}</p>}
                                        {section.areas_of_improvement && (
                                          <div className="d-flex align-items-start gap-1 mt-1" style={{ fontSize: 11, color: "#d97706" }}>
                                            <TrendingUp size={13} style={{ flexShrink: 0, marginTop: 2 }} />
                                            <span>{section.areas_of_improvement}</span>
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                  {(screeningData.key_strengths || screeningData.overall_recommendation || screeningData.priority_improvements) && (
                                    <div className="mt-3" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                      {screeningData.key_strengths && (
                                        <div className="d-flex align-items-start gap-2 p-3" style={{ background: "#ecfdf5", borderRadius: 10, border: "1px solid #a7f3d0" }}>
                                          <Target size={16} style={{ color: "#059669", flexShrink: 0, marginTop: 2 }} />
                                          <div>
                                            <div style={{ fontSize: 11, fontWeight: 700, color: "#059669", textTransform: "uppercase", letterSpacing: 0.5 }}>Key Strengths</div>
                                            <div style={{ fontSize: 13, color: "#065f46" }}>{screeningData.key_strengths}</div>
                                          </div>
                                        </div>
                                      )}
                                      {screeningData.priority_improvements && (
                                        <div className="d-flex align-items-start gap-2 p-3" style={{ background: "#fffbeb", borderRadius: 10, border: "1px solid #fde68a" }}>
                                          <AlertCircle size={16} style={{ color: "#d97706", flexShrink: 0, marginTop: 2 }} />
                                          <div>
                                            <div style={{ fontSize: 11, fontWeight: 700, color: "#d97706", textTransform: "uppercase", letterSpacing: 0.5 }}>Priority Improvements</div>
                                            <div style={{ fontSize: 13, color: "#92400e" }}>{screeningData.priority_improvements}</div>
                                          </div>
                                        </div>
                                      )}
                                      {screeningData.overall_recommendation && (
                                        <div className="d-flex align-items-start gap-2 p-3" style={{ background: "#eff6ff", borderRadius: 10, border: "1px solid #bfdbfe" }}>
                                          <Sparkles size={16} style={{ color: "#2563eb", flexShrink: 0, marginTop: 2 }} />
                                          <div>
                                            <div style={{ fontSize: 11, fontWeight: 700, color: "#2563eb", textTransform: "uppercase", letterSpacing: 0.5 }}>Recommendation</div>
                                            <div style={{ fontSize: 13, color: "#1e40af" }}>{screeningData.overall_recommendation}</div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
          
                              {/* Screening Questions */}
                              {screeningData.questions && screeningData.questions.length > 0 && (
                                <div className="mb-4 screening-section" style={{ animationDelay: "0.2s" }}>
                                  <h6 className="d-flex align-items-center gap-2 mb-3" style={{ fontWeight: 700, color: "#374151", fontSize: 14 }}>
                                    <div style={{ width: 30, height: 30, borderRadius: 8, background: "linear-gradient(135deg, #ede9fe, #ddd6fe)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                      <ListChecks size={16} style={{ color: "#7c3aed" }} />
                                    </div>
                                    Screening Questions
                                    <span style={{ fontSize: 10, fontWeight: 600, background: "#f3f4f6", color: "#374151", padding: "2px 8px", borderRadius: 20 }}>{screeningData.questions.length}</span>
                                  </h6>
                                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                    {screeningData.questions.map((q, idx) => (
                                      <div key={idx} className="d-flex align-items-start gap-3 screening-question-item" style={{ background: "#faf5ff", borderRadius: 10, padding: "12px 16px", borderLeft: "3px solid #7c3aed", animation: `slideInLeft 0.3s ease ${0.05 * idx}s forwards`, opacity: 0 }}>
                                        <span style={{ background: "linear-gradient(135deg, #7c3aed, #6d28d9)", color: "#fff", borderRadius: "50%", width: 24, height: 24, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, flexShrink: 0, marginTop: 1, boxShadow: "0 2px 6px rgba(124,58,237,0.3)" }}>{idx + 1}</span>
                                        <span style={{ fontSize: 13, color: "#374151", lineHeight: 1.5 }}>{q}</span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
          
                              {/* Call Recording */}
                              {screeningData.recording && (
                                <div className="mb-4 screening-section" style={{ animationDelay: "0.3s" }}>
                                  <h6 className="d-flex align-items-center gap-2 mb-3" style={{ fontWeight: 700, color: "#374151", fontSize: 14 }}>
                                    <div style={{ width: 30, height: 30, borderRadius: 8, background: "linear-gradient(135deg, #fef3c7, #fde68a)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                      <Volume2 size={16} style={{ color: "#d97706" }} />
                                    </div>
                                    Call Recording
                                  </h6>
                                  <div className="screening-recording-card" style={{ background: "linear-gradient(135deg, #fffbeb, #fef3c7)", borderRadius: 12, padding: "18px 20px", border: "1px solid #fde68a" }}>
                                    <div className="d-flex align-items-center gap-3">
                                      <div style={{ width: 44, height: 44, borderRadius: "50%", background: "linear-gradient(135deg, #f59e0b, #d97706)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, boxShadow: "0 4px 12px rgba(245,158,11,0.3)" }}>
                                        <Play size={20} style={{ color: "#fff" }} />
                                      </div>
                                      <div style={{ flex: 1 }}>
                                        <audio controls style={{ width: "100%", height: 36 }}>
                                          <source src={screeningData.recording} type="audio/wav" />
                                        </audio>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
          
                              {/* Conversation Transcript */}
                              {screeningData.transcript && screeningData.transcript.length > 0 && (
                                <div className="screening-section" style={{ animationDelay: "0.4s" }}>
                                  <h6 className="d-flex align-items-center gap-2 mb-3" style={{ fontWeight: 700, color: "#374151", fontSize: 14 }}>
                                    <div style={{ width: 30, height: 30, borderRadius: 8, background: "linear-gradient(135deg, #dbeafe, #bfdbfe)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                      <MessageCircle size={16} style={{ color: "#2563eb" }} />
                                    </div>
                                    Conversation Transcript
                                    <span style={{ fontSize: 10, fontWeight: 600, background: "linear-gradient(135deg, #667eea, #764ba2)", color: "#fff", padding: "2px 8px", borderRadius: 20 }}>{screeningData.transcript.length} messages</span>
                                  </h6>
                                  <div className="screening-transcript-container" style={{ maxHeight: 400, overflowY: "auto", borderRadius: 14, padding: 20, background: "linear-gradient(180deg, #f9fafb, #f3f4f6)", border: "1px solid #e5e7eb" }}>
                                    {screeningData.transcript.map((msg, idx) => (
                                      <div key={idx} className={`d-flex mb-3 screening-chat-bubble ${msg.role === "ai" ? "justify-content-start" : "justify-content-end"}`} style={{ animation: `${msg.role === "ai" ? "slideInLeft" : "slideInRight"} 0.3s ease ${0.05 * idx}s forwards`, opacity: 0 }}>
                                        {msg.role === "ai" && (
                                          <div title="AI Recruiter" style={{ width: 34, height: 34, borderRadius: "50%", background: "linear-gradient(135deg, #667eea, #764ba2)", display: "flex", alignItems: "center", justifyContent: "center", marginRight: 10, flexShrink: 0, marginTop: 2, boxShadow: "0 2px 8px rgba(102,126,234,0.3)", cursor: "default" }}>
                                            <Bot size={17} style={{ color: "#fff" }} />
                                          </div>
                                        )}
                                        <div style={{ maxWidth: "72%", padding: "12px 16px", borderRadius: msg.role === "ai" ? "4px 18px 18px 18px" : "18px 4px 18px 18px", background: msg.role === "ai" ? "#fff" : "linear-gradient(135deg, #667eea, #764ba2)", color: msg.role === "ai" ? "#1f2937" : "#fff", fontSize: 13, lineHeight: 1.6, boxShadow: msg.role === "ai" ? "0 2px 8px rgba(0,0,0,0.06)" : "0 2px 12px rgba(102,126,234,0.3)", border: msg.role === "ai" ? "1px solid #f0f0f0" : "none" }}>
                                          <div className="d-flex align-items-center gap-1 mb-1" style={{ fontSize: 11, fontWeight: 700, opacity: msg.role === "ai" ? 0.5 : 0.8 }}>
                                            {msg.role === "ai" ? <Bot size={11} /> : <User size={11} />}
                                            {msg.role === "ai" ? "AI Recruiter" : "Candidate"}
                                          </div>
                                          <p className="mb-0">{msg.content}</p>
                                        </div>
                                        {msg.role !== "ai" && (
                                          <div title="Candidate" style={{ width: 34, height: 34, borderRadius: "50%", background: "linear-gradient(135deg, #34d399, #059669)", display: "flex", alignItems: "center", justifyContent: "center", marginLeft: 10, flexShrink: 0, marginTop: 2, boxShadow: "0 2px 8px rgba(52,211,153,0.3)", cursor: "default" }}>
                                            <User size={17} style={{ color: "#fff" }} />
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          </>
                        ) : null}
                      </ModalBody>
          
                      <ModalBody style={{ background: "linear-gradient(180deg, #fff, #f9fafb)", borderTop: "1px solid #f0f0f0", display: "flex", justifyContent: "center", padding: "14px 24px" }}>
                        <button
                          type="button"
                          className="btn btn-primary"
                          style={{ borderRadius: 10, padding: "9px 32px", fontWeight: 600, fontSize: 13, boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
                          onClick={() => setScreeningModal(false)}
                        >
                          Close
                        </button>
                      </ModalBody>
                    </Modal>
                    <Modal
  isOpen={recruiterProfileModal.open}
  toggle={() => setRecruiterProfileModal({ open: false, row: null })}
  size="xl"
  centered
  className="recruiter-detail-modal"
  style={{ width: "96vw", maxWidth: "1500px" }}
>
  {/* Replace the entire <ModalHeader>...</ModalHeader> block with this: */}
<div
  style={{
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: 12,
    background: "linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)",
    padding: "18px 24px",
    borderRadius: "14px 14px 0 0",
  }}
>
  {/* Left: avatar + name + email */}
  <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
    <div style={{
      width: 42, height: 42, borderRadius: "50%",
      background: "rgba(255,255,255,0.2)",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: 16, fontWeight: 800, color: "#fff",
      border: "2px solid rgba(255,255,255,0.35)",
      flexShrink: 0,
    }}>
      {getInitials(recruiterProfileModal.row?.recruiterName)}
    </div>
    <div style={{ minWidth: 0 }}>
      <div style={{ fontWeight: 700, fontSize: 16, color: "#fff", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {recruiterProfileModal.row?.recruiterName}
      </div>
      <div style={{ fontSize: 12, color: "rgba(255,255,255,0.85)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {recruiterProfileModal.row?.recruiterEmail} &nbsp;·&nbsp; Activity Overview
      </div>
    </div>
  </div>

  {/* Spacer */}
  <div style={{ flex: 1 }} />

  {/* Right: Export + Close */}
  <div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
    <button
      type="button"
      className="btn recruiter-detail-modal-export"
      onClick={exportRecruiterProfileAllExcel}
      disabled={!recruiterProfileModal.row}
      style={{
        background: "linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%)",
        color: "#fff",
        border: "none",
        boxShadow: "0 10px 24px rgba(29, 78, 216, 0.28)",
        padding: "9px 15px",
        fontWeight: 800,
        letterSpacing: "0.01em",
        minWidth: "172px",
        height: "42px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        borderRadius: "10px",
      }}
    >
      <FaFileExcel /> Export All Data
    </button>

    <button
      type="button"
      onClick={() => setRecruiterProfileModal({ open: false, row: null })}
      aria-label="Close modal"
      title="Close"
      style={{
        width: 42,
        height: 42,
        borderRadius: "50%",
        border: "none",
        background: "rgba(255,255,255,0.18)",
        color: "#fff",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 8px 18px rgba(15, 23, 42, 0.2)",
        cursor: "pointer",
      }}
    >
      <FaTimes size={16} />
    </button>
  </div>
</div>
 
  <ModalBody style={{ padding: 0 }}>
    {recruiterProfileModal.row && (() => {
      const row = recruiterProfileModal.row
 
      // ── Tab bar ────────────────────────────────────────────────────────────
      const visibleProfileTabs = RECRUITER_PROFILE_TABS.filter(tab => tab.key !== "candidates_db")
      const activeTab = visibleProfileTabs.find(t => t.key === recruiterProfileTab) || visibleProfileTabs[0]
      const rows = getRecruiterProfileTabRows(recruiterProfileTab)
 
      // Derive visible columns from the rows themselves, filtered by TAB_COLUMNS whitelist
      const allowedKeys = TAB_COLUMNS[recruiterProfileTab] || []
      const presentKeys = rows.length
        ? allowedKeys.filter(k => rows.some(r => r[k] !== undefined && r[k] !== null && r[k] !== ""))
        : allowedKeys.slice(0, 5)
      const dedupedPresentKeys = dedupeColumnsByHeader(presentKeys)
 
      // Always append recording_url if any row has it and tab is click_to_call or screening
      const hasRecording = rows.some(r => r.recording_url)
      const visibleColumns = hasRecording && !dedupedPresentKeys.includes("recording_url")
        ? [...dedupedPresentKeys, "recording_url"]
        : dedupedPresentKeys
 
      // For screening tab: also check secondary_external_call_id
      const hasTranscript = recruiterProfileTab === "screening" && rows.some(r => r.secondary_external_call_id)
 
      return (
        <div>
          {/* Tab bar */}
          <div className="mb-2" style={{
            display: "flex", gap: 0, borderBottom: "2px solid #e5e7eb",
            background: "#f8fafc", padding: "0 16px",
          }}>
            {visibleProfileTabs.map(tab => {
              const count = row[tab.countKey] ?? (row[tab.detailKey]?.length ?? 0)
              const isActive = recruiterProfileTab === tab.key
              return (
                <button
                  key={tab.key}
                  type="button"
                  className={isActive ? "activeBorder" : "inActiveBorder"}
                  onClick={() => setRecruiterProfileTab(tab.key)}
                  style={{
                    display: "flex", alignItems: "center", gap: 6,
                    padding: "12px 16px",
                    border: "none",
                    // borderBottom: isActive ? `3px solid ${tab.color}` : "3px solid transparent",
                    background: "transparent",
                    color: isActive ? tab.color : "#64748b",
                    fontWeight: isActive ? 700 : 500,
                    fontSize: 13,
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    transition: "all 0.15s",
                    marginBottom: "4px",
                    marginTop: "4px",
                    marginRight: "8px",
                    borderRadius: "0.375rem",
                  }}
                >
                  <span style={{ fontSize: 15 }}>{tab.icon}</span>
                  {tab.label}
                  <span style={{
                    background: isActive ? tab.color : "#e2e8f0",
                    color: isActive ? "#fff" : "#64748b",
                    borderRadius: 20, padding: "1px 8px",
                    fontSize: 11, fontWeight: 700,
                    minWidth: 22, textAlign: "center",
                  }}>
                    {count}
                  </span>
                  <span
                    role="button"
                    title={`Download ${tab.label}`}
                    onClick={e => {
                      e.stopPropagation()
                      exportRecruiterProfileTabExcel(tab.key, false)
                    }}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 22,
                      height: 22,
                      borderRadius: 999,
                      border: "1px solid rgba(15,23,42,0.08)",
                      background: "#fff",
                      color: tab.color,
                      marginLeft: 4,
                    }}
                  >
                    <FaDownload size={11} />
                  </span>
                </button>
              )
            })}
          </div>
 
          {/* Tab content */}
          <div style={{ padding: "0 0 8px" }}>
            {rows.length === 0 ? (
              <div style={{
                textAlign: "center", padding: "48px 24px",
                color: "#94a3b8", fontSize: 14,
              }}>
                <div style={{ fontSize: 40, marginBottom: 10 }}>{activeTab.icon}</div>
                No {activeTab.label.toLowerCase()} records found.
              </div>
            ) : (
              <div style={{ overflowX: "auto", maxHeight: "60vh", overflowY: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.85rem" }}>
                  <thead>
                    <tr style={{ background: "#f1f5f9", position: "sticky", top: 0, zIndex: 2 }}>
                      <th style={{ padding: "10px 14px", textAlign: "center", color: "#475569", fontWeight: 700, borderBottom: "2px solid #e2e8f0", whiteSpace: "nowrap", minWidth: 40 }}>S.No</th>
                      {visibleColumns.map(col => (
                        <th key={col} style={{
                          padding: "10px 14px", textAlign: "left",
                          color: activeTab.color, fontWeight: 800,
                          background: activeTab.bg,
                          borderBottom: `2px solid ${activeTab.color}`,
                          whiteSpace: "nowrap",
                          minWidth: col.includes("job_title") ? 200 : col === "recording_url" ? 220 : col === "_company_name" ? 240 : 130,
                          borderLeft: `1px solid ${activeTab.border}`,
                        }}>
                          {prettifyKey(col)}
                        </th>
                      ))}
                      {hasTranscript && (
                        <th style={{ padding: "10px 14px", textAlign: "center", color: "#475569", fontWeight: 700, borderBottom: "2px solid #e2e8f0", whiteSpace: "nowrap", minWidth: 130, borderLeft: "1px solid #e2e8f0" }}>
                          Transcript
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((item, idx) => (
                      <tr key={item.id || item.job_candidate_id || idx}
                        style={{ background: idx % 2 === 0 ? "#fff" : "#f8fafc" }}
                      >
                        <td style={{ padding: "8px 14px", textAlign: "center", color: "#94a3b8", fontSize: 12, borderBottom: "1px solid #f1f5f9" }}>
                          {idx + 1}
                        </td>
                        {visibleColumns.map(col => (
                          <td key={`${idx}-${col}`} style={{
                            padding: "8px 14px",
                            color: "#334155",
                            borderBottom: "1px solid #f1f5f9",
                            borderLeft: "1px solid #f1f5f9",
                            whiteSpace: col === "recording_url" ? "normal" : "nowrap",
                            maxWidth: col.includes("job_title") ? 280 : 200,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}>
                            {col === "recording_url" && item[col] ? (
                              <RecordingPlayer
                                src={getRecordingPlayUrl(item[col])}
                                currentPlayingRef={currentPlayingRef}
                              />
                            ) : (
                              formatDetailValue(col, item[col], item)
                            )}
                          </td>
                        ))}
                        {hasTranscript && (
                          <td style={{ padding: "8px 14px", textAlign: "center", borderBottom: "1px solid #f1f5f9", borderLeft: "1px solid #f1f5f9" }}>
                            {item.secondary_external_call_id ? (
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                style={{ fontSize: 11, padding: "3px 10px" }}
                                onClick={() => handleViewCallTranscript(item)}
                              >
                                View Transcript
                              </button>
                            ) : (
                              <span style={{ fontSize: 11, color: "#94a3b8" }}>—</span>
                            )}
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )
    })()}
  </ModalBody>
</Modal>

        </>
        
        
      )}
    </div>
  )
}

export default JobOrderRecruiterReport
